import {
  createUseReadContract,
  createUseWriteContract,
  createUseSimulateContract,
  createUseWatchContractEvent,
} from 'wagmi/codegen'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Address
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const addressAbi = [
  {
    type: 'error',
    inputs: [{ name: 'target', internalType: 'address', type: 'address' }],
    name: 'AddressEmptyCode',
  },
  {
    type: 'error',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'AddressInsufficientBalance',
  },
  { type: 'error', inputs: [], name: 'FailedInnerCall' },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ERC1155
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const erc1155Abi = [
  {
    type: 'error',
    inputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'balance', internalType: 'uint256', type: 'uint256' },
      { name: 'needed', internalType: 'uint256', type: 'uint256' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ERC1155InsufficientBalance',
  },
  {
    type: 'error',
    inputs: [{ name: 'approver', internalType: 'address', type: 'address' }],
    name: 'ERC1155InvalidApprover',
  },
  {
    type: 'error',
    inputs: [
      { name: 'idsLength', internalType: 'uint256', type: 'uint256' },
      { name: 'valuesLength', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ERC1155InvalidArrayLength',
  },
  {
    type: 'error',
    inputs: [{ name: 'operator', internalType: 'address', type: 'address' }],
    name: 'ERC1155InvalidOperator',
  },
  {
    type: 'error',
    inputs: [{ name: 'receiver', internalType: 'address', type: 'address' }],
    name: 'ERC1155InvalidReceiver',
  },
  {
    type: 'error',
    inputs: [{ name: 'sender', internalType: 'address', type: 'address' }],
    name: 'ERC1155InvalidSender',
  },
  {
    type: 'error',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'owner', internalType: 'address', type: 'address' },
    ],
    name: 'ERC1155MissingApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'approved', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'ids',
        internalType: 'uint256[]',
        type: 'uint256[]',
        indexed: false,
      },
      {
        name: 'values',
        internalType: 'uint256[]',
        type: 'uint256[]',
        indexed: false,
      },
    ],
    name: 'TransferBatch',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: false },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'TransferSingle',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'value', internalType: 'string', type: 'string', indexed: false },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: true },
    ],
    name: 'URI',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'accounts', internalType: 'address[]', type: 'address[]' },
      { name: 'ids', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    name: 'balanceOfBatch',
    outputs: [{ name: '', internalType: 'uint256[]', type: 'uint256[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'operator', internalType: 'address', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'ids', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'values', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeBatchTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'approved', internalType: 'bool', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    name: 'uri',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ERC1155Holder
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const erc1155HolderAbi = [
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256[]', type: 'uint256[]' },
      { name: '', internalType: 'uint256[]', type: 'uint256[]' },
      { name: '', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'onERC1155BatchReceived',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'onERC1155Received',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ERC165
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const erc165Abi = [
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ERC20
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const erc20Abi = [
  {
    type: 'error',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'allowance', internalType: 'uint256', type: 'uint256' },
      { name: 'needed', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ERC20InsufficientAllowance',
  },
  {
    type: 'error',
    inputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'balance', internalType: 'uint256', type: 'uint256' },
      { name: 'needed', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ERC20InsufficientBalance',
  },
  {
    type: 'error',
    inputs: [{ name: 'approver', internalType: 'address', type: 'address' }],
    name: 'ERC20InvalidApprover',
  },
  {
    type: 'error',
    inputs: [{ name: 'receiver', internalType: 'address', type: 'address' }],
    name: 'ERC20InvalidReceiver',
  },
  {
    type: 'error',
    inputs: [{ name: 'sender', internalType: 'address', type: 'address' }],
    name: 'ERC20InvalidSender',
  },
  {
    type: 'error',
    inputs: [{ name: 'spender', internalType: 'address', type: 'address' }],
    name: 'ERC20InvalidSpender',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ERC721
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const erc721Abi = [
  { type: 'error', inputs: [], name: 'AccountBalanceOverflow' },
  { type: 'error', inputs: [], name: 'BalanceQueryForZeroAddress' },
  { type: 'error', inputs: [], name: 'NotOwnerNorApproved' },
  { type: 'error', inputs: [], name: 'TokenAlreadyExists' },
  { type: 'error', inputs: [], name: 'TokenDoesNotExist' },
  { type: 'error', inputs: [], name: 'TransferFromIncorrectOwner' },
  { type: 'error', inputs: [], name: 'TransferToNonERC721ReceiverImplementer' },
  { type: 'error', inputs: [], name: 'TransferToZeroAddress' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: true },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'isApproved',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'ApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: true },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: 'result', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'id', internalType: 'uint256', type: 'uint256' }],
    name: 'getApproved',
    outputs: [{ name: 'result', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'operator', internalType: 'address', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ name: 'result', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'id', internalType: 'uint256', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ name: 'result', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'isApproved', internalType: 'bool', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: 'result', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'id', internalType: 'uint256', type: 'uint256' }],
    name: 'tokenURI',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ERC721A
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const erc721AAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: 'name_', internalType: 'string', type: 'string' },
      { name: 'symbol_', internalType: 'string', type: 'string' },
    ],
    stateMutability: 'nonpayable',
  },
  { type: 'error', inputs: [], name: 'ApprovalCallerNotOwnerNorApproved' },
  { type: 'error', inputs: [], name: 'ApprovalQueryForNonexistentToken' },
  { type: 'error', inputs: [], name: 'BalanceQueryForZeroAddress' },
  { type: 'error', inputs: [], name: 'MintERC2309QuantityExceedsLimit' },
  { type: 'error', inputs: [], name: 'MintToZeroAddress' },
  { type: 'error', inputs: [], name: 'MintZeroQuantity' },
  { type: 'error', inputs: [], name: 'NotCompatibleWithSpotMints' },
  { type: 'error', inputs: [], name: 'OwnerQueryForNonexistentToken' },
  { type: 'error', inputs: [], name: 'OwnershipNotInitializedForExtraData' },
  { type: 'error', inputs: [], name: 'SequentialMintExceedsLimit' },
  { type: 'error', inputs: [], name: 'SequentialUpToTooSmall' },
  { type: 'error', inputs: [], name: 'SpotMintTokenIdTooSmall' },
  { type: 'error', inputs: [], name: 'TokenAlreadyExists' },
  { type: 'error', inputs: [], name: 'TransferCallerNotOwnerNorApproved' },
  { type: 'error', inputs: [], name: 'TransferFromIncorrectOwner' },
  { type: 'error', inputs: [], name: 'TransferToNonERC721ReceiverImplementer' },
  { type: 'error', inputs: [], name: 'TransferToZeroAddress' },
  { type: 'error', inputs: [], name: 'URIQueryForNonexistentToken' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'approved',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'approved', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fromTokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'toTokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
    ],
    name: 'ConsecutiveTransfer',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'getApproved',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'operator', internalType: 'address', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
      { name: '_data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'approved', internalType: 'bool', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'tokenURI',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: 'result', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ERC721A__IERC721Receiver
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const erc721AIerc721ReceiverAbi = [
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'onERC721Received',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'nonpayable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ERC721Holder
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const erc721HolderAbi = [
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'onERC721Received',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'nonpayable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IERC1155
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ierc1155Abi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'approved', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'ids',
        internalType: 'uint256[]',
        type: 'uint256[]',
        indexed: false,
      },
      {
        name: 'values',
        internalType: 'uint256[]',
        type: 'uint256[]',
        indexed: false,
      },
    ],
    name: 'TransferBatch',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: false },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'TransferSingle',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'value', internalType: 'string', type: 'string', indexed: false },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: true },
    ],
    name: 'URI',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'accounts', internalType: 'address[]', type: 'address[]' },
      { name: 'ids', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    name: 'balanceOfBatch',
    outputs: [{ name: '', internalType: 'uint256[]', type: 'uint256[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'operator', internalType: 'address', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'ids', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'values', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeBatchTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'approved', internalType: 'bool', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IERC1155Errors
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ierc1155ErrorsAbi = [
  {
    type: 'error',
    inputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'balance', internalType: 'uint256', type: 'uint256' },
      { name: 'needed', internalType: 'uint256', type: 'uint256' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ERC1155InsufficientBalance',
  },
  {
    type: 'error',
    inputs: [{ name: 'approver', internalType: 'address', type: 'address' }],
    name: 'ERC1155InvalidApprover',
  },
  {
    type: 'error',
    inputs: [
      { name: 'idsLength', internalType: 'uint256', type: 'uint256' },
      { name: 'valuesLength', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ERC1155InvalidArrayLength',
  },
  {
    type: 'error',
    inputs: [{ name: 'operator', internalType: 'address', type: 'address' }],
    name: 'ERC1155InvalidOperator',
  },
  {
    type: 'error',
    inputs: [{ name: 'receiver', internalType: 'address', type: 'address' }],
    name: 'ERC1155InvalidReceiver',
  },
  {
    type: 'error',
    inputs: [{ name: 'sender', internalType: 'address', type: 'address' }],
    name: 'ERC1155InvalidSender',
  },
  {
    type: 'error',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'owner', internalType: 'address', type: 'address' },
    ],
    name: 'ERC1155MissingApprovalForAll',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IERC1155MetadataURI
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ierc1155MetadataUriAbi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'approved', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'ids',
        internalType: 'uint256[]',
        type: 'uint256[]',
        indexed: false,
      },
      {
        name: 'values',
        internalType: 'uint256[]',
        type: 'uint256[]',
        indexed: false,
      },
    ],
    name: 'TransferBatch',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: false },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'TransferSingle',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'value', internalType: 'string', type: 'string', indexed: false },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: true },
    ],
    name: 'URI',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'accounts', internalType: 'address[]', type: 'address[]' },
      { name: 'ids', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    name: 'balanceOfBatch',
    outputs: [{ name: '', internalType: 'uint256[]', type: 'uint256[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'operator', internalType: 'address', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'ids', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'values', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeBatchTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'approved', internalType: 'bool', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'id', internalType: 'uint256', type: 'uint256' }],
    name: 'uri',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IERC1155Receiver
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ierc1155ReceiverAbi = [
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'ids', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'values', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'onERC1155BatchReceived',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'onERC1155Received',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IERC165
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ierc165Abi = [
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IERC20
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ierc20Abi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IERC20Errors
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ierc20ErrorsAbi = [
  {
    type: 'error',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'allowance', internalType: 'uint256', type: 'uint256' },
      { name: 'needed', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ERC20InsufficientAllowance',
  },
  {
    type: 'error',
    inputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'balance', internalType: 'uint256', type: 'uint256' },
      { name: 'needed', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ERC20InsufficientBalance',
  },
  {
    type: 'error',
    inputs: [{ name: 'approver', internalType: 'address', type: 'address' }],
    name: 'ERC20InvalidApprover',
  },
  {
    type: 'error',
    inputs: [{ name: 'receiver', internalType: 'address', type: 'address' }],
    name: 'ERC20InvalidReceiver',
  },
  {
    type: 'error',
    inputs: [{ name: 'sender', internalType: 'address', type: 'address' }],
    name: 'ERC20InvalidSender',
  },
  {
    type: 'error',
    inputs: [{ name: 'spender', internalType: 'address', type: 'address' }],
    name: 'ERC20InvalidSpender',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IERC20Metadata
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ierc20MetadataAbi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IERC20Permit
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ierc20PermitAbi = [
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'permit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IERC721
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ierc721Abi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'approved',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'approved', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: 'balance', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'getApproved',
    outputs: [{ name: 'operator', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'operator', internalType: 'address', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'approved', internalType: 'bool', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IERC721A
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ierc721AAbi = [
  { type: 'error', inputs: [], name: 'ApprovalCallerNotOwnerNorApproved' },
  { type: 'error', inputs: [], name: 'ApprovalQueryForNonexistentToken' },
  { type: 'error', inputs: [], name: 'BalanceQueryForZeroAddress' },
  { type: 'error', inputs: [], name: 'MintERC2309QuantityExceedsLimit' },
  { type: 'error', inputs: [], name: 'MintToZeroAddress' },
  { type: 'error', inputs: [], name: 'MintZeroQuantity' },
  { type: 'error', inputs: [], name: 'NotCompatibleWithSpotMints' },
  { type: 'error', inputs: [], name: 'OwnerQueryForNonexistentToken' },
  { type: 'error', inputs: [], name: 'OwnershipNotInitializedForExtraData' },
  { type: 'error', inputs: [], name: 'SequentialMintExceedsLimit' },
  { type: 'error', inputs: [], name: 'SequentialUpToTooSmall' },
  { type: 'error', inputs: [], name: 'SpotMintTokenIdTooSmall' },
  { type: 'error', inputs: [], name: 'TokenAlreadyExists' },
  { type: 'error', inputs: [], name: 'TransferCallerNotOwnerNorApproved' },
  { type: 'error', inputs: [], name: 'TransferFromIncorrectOwner' },
  { type: 'error', inputs: [], name: 'TransferToNonERC721ReceiverImplementer' },
  { type: 'error', inputs: [], name: 'TransferToZeroAddress' },
  { type: 'error', inputs: [], name: 'URIQueryForNonexistentToken' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'approved',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'approved', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fromTokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'toTokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
    ],
    name: 'ConsecutiveTransfer',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: 'balance', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'getApproved',
    outputs: [{ name: 'operator', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'operator', internalType: 'address', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: '_approved', internalType: 'bool', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'tokenURI',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IERC721Errors
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ierc721ErrorsAbi = [
  {
    type: 'error',
    inputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
      { name: 'owner', internalType: 'address', type: 'address' },
    ],
    name: 'ERC721IncorrectOwner',
  },
  {
    type: 'error',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ERC721InsufficientApproval',
  },
  {
    type: 'error',
    inputs: [{ name: 'approver', internalType: 'address', type: 'address' }],
    name: 'ERC721InvalidApprover',
  },
  {
    type: 'error',
    inputs: [{ name: 'operator', internalType: 'address', type: 'address' }],
    name: 'ERC721InvalidOperator',
  },
  {
    type: 'error',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'ERC721InvalidOwner',
  },
  {
    type: 'error',
    inputs: [{ name: 'receiver', internalType: 'address', type: 'address' }],
    name: 'ERC721InvalidReceiver',
  },
  {
    type: 'error',
    inputs: [{ name: 'sender', internalType: 'address', type: 'address' }],
    name: 'ERC721InvalidSender',
  },
  {
    type: 'error',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'ERC721NonexistentToken',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IERC721Receiver
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ierc721ReceiverAbi = [
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'onERC721Received',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'nonpayable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IMagnifyCashV1
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const iMagnifyCashV1Abi = [
  {
    type: 'function',
    inputs: [
      { name: '_lendingDeskId', internalType: 'uint256', type: 'uint256' },
      { name: '_amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'depositLendingDeskLiquidity',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_loanId', internalType: 'uint256', type: 'uint256' }],
    name: 'getLoanAmountDue',
    outputs: [{ name: 'amount', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_erc20', internalType: 'address', type: 'address' },
      { name: '_depositAmount', internalType: 'uint256', type: 'uint256' },
      {
        name: '_loanConfigs',
        internalType: 'struct IMagnifyCashV1.LoanConfig[]',
        type: 'tuple[]',
        components: [
          { name: 'nftCollection', internalType: 'address', type: 'address' },
          {
            name: 'nftCollectionIsErc1155',
            internalType: 'bool',
            type: 'bool',
          },
          { name: 'minAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'maxAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'minInterest', internalType: 'uint32', type: 'uint32' },
          { name: 'maxInterest', internalType: 'uint32', type: 'uint32' },
          { name: 'minDuration', internalType: 'uint32', type: 'uint32' },
          { name: 'maxDuration', internalType: 'uint32', type: 'uint32' },
        ],
      },
    ],
    name: 'initializeNewLendingDesk',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_lendingDeskId', internalType: 'uint64', type: 'uint64' },
      { name: '_nftCollection', internalType: 'address', type: 'address' },
      { name: '_nftId', internalType: 'uint256', type: 'uint256' },
      { name: '_duration', internalType: 'uint32', type: 'uint32' },
      { name: '_amount', internalType: 'uint256', type: 'uint256' },
      { name: '_maxInterestAllowed', internalType: 'uint32', type: 'uint32' },
    ],
    name: 'initializeNewLoan',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_loanId', internalType: 'uint256', type: 'uint256' }],
    name: 'liquidateDefaultedLoan',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_loanId', internalType: 'uint256', type: 'uint256' },
      { name: '_amount', internalType: 'uint256', type: 'uint256' },
      { name: '_resolve', internalType: 'bool', type: 'bool' },
    ],
    name: 'makeLoanPayment',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_lendingDeskId', internalType: 'uint256', type: 'uint256' },
      { name: '_nftCollection', internalType: 'address', type: 'address' },
    ],
    name: 'removeLendingDeskLoanConfig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_lendingDeskId', internalType: 'uint256', type: 'uint256' },
      {
        name: '_loanConfigs',
        internalType: 'struct IMagnifyCashV1.LoanConfig[]',
        type: 'tuple[]',
        components: [
          { name: 'nftCollection', internalType: 'address', type: 'address' },
          {
            name: 'nftCollectionIsErc1155',
            internalType: 'bool',
            type: 'bool',
          },
          { name: 'minAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'maxAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'minInterest', internalType: 'uint32', type: 'uint32' },
          { name: 'maxInterest', internalType: 'uint32', type: 'uint32' },
          { name: 'minDuration', internalType: 'uint32', type: 'uint32' },
          { name: 'maxDuration', internalType: 'uint32', type: 'uint32' },
        ],
      },
    ],
    name: 'setLendingDeskLoanConfigs',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_lendingDeskId', internalType: 'uint256', type: 'uint256' },
      { name: '_freezed', internalType: 'bool', type: 'bool' },
    ],
    name: 'setLendingDeskState',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_loanOriginationFee', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setLoanOriginationFee',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_paused', internalType: 'bool', type: 'bool' }],
    name: 'setPaused',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_platformWallet', internalType: 'address', type: 'address' },
    ],
    name: 'setPlatformWallet',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_lendingDeskId', internalType: 'uint256', type: 'uint256' },
      { name: '_amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'withdrawLendingDeskLiquidity',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IMagnifyERC721V1
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const iMagnifyErc721V1Abi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'approved',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'approved', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: 'balance', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'getApproved',
    outputs: [{ name: 'operator', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'operator', internalType: 'address', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'approved', internalType: 'bool', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// LibString
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const libStringAbi = [
  { type: 'error', inputs: [], name: 'HexLengthInsufficient' },
  { type: 'error', inputs: [], name: 'TooBigForSmallString' },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// MagnifyCashV1
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const magnifyCashV1Abi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_obligationNotes', internalType: 'address', type: 'address' },
      { name: '_lendingKeys', internalType: 'address', type: 'address' },
      { name: '_loanOriginationFee', internalType: 'uint256', type: 'uint256' },
      { name: '_platformWallet', internalType: 'address', type: 'address' },
      { name: '_initialOwner', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'error',
    inputs: [{ name: 'target', internalType: 'address', type: 'address' }],
    name: 'AddressEmptyCode',
  },
  {
    type: 'error',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'AddressInsufficientBalance',
  },
  { type: 'error', inputs: [], name: 'AlreadyInitialized' },
  { type: 'error', inputs: [], name: 'AmountIsZero' },
  { type: 'error', inputs: [], name: 'CallerIsNotBorrower' },
  { type: 'error', inputs: [], name: 'CallerIsNotLender' },
  { type: 'error', inputs: [], name: 'CallerIsNotLendingDeskOwner' },
  { type: 'error', inputs: [], name: 'ERC20IsZeroAddr' },
  { type: 'error', inputs: [], name: 'EnforcedPause' },
  { type: 'error', inputs: [], name: 'ExpectedPause' },
  { type: 'error', inputs: [], name: 'FailedInnerCall' },
  { type: 'error', inputs: [], name: 'InsufficientLendingDeskBalance' },
  { type: 'error', inputs: [], name: 'InterestRateTooHigh' },
  { type: 'error', inputs: [], name: 'InvalidInterest' },
  { type: 'error', inputs: [], name: 'InvalidLendingDeskId' },
  { type: 'error', inputs: [], name: 'InvalidLoanId' },
  { type: 'error', inputs: [], name: 'InvalidNFTCollection' },
  { type: 'error', inputs: [], name: 'LendingDeskIsNotActive' },
  { type: 'error', inputs: [], name: 'LendingDeskIsNotEmpty' },
  { type: 'error', inputs: [], name: 'LendingDeskIsNotFrozen' },
  { type: 'error', inputs: [], name: 'LendingKeysIsZeroAddr' },
  { type: 'error', inputs: [], name: 'LoanAmountTooHigh' },
  { type: 'error', inputs: [], name: 'LoanAmountTooLow' },
  { type: 'error', inputs: [], name: 'LoanDurationTooHigh' },
  { type: 'error', inputs: [], name: 'LoanDurationTooLow' },
  { type: 'error', inputs: [], name: 'LoanHasDefaulted' },
  { type: 'error', inputs: [], name: 'LoanHasNotDefaulted' },
  { type: 'error', inputs: [], name: 'LoanIsNotActive' },
  { type: 'error', inputs: [], name: 'LoanMustBeActiveForMin1Hour' },
  { type: 'error', inputs: [], name: 'LoanPaymentExceedsDebt' },
  { type: 'error', inputs: [], name: 'MaxAmountIsLessThanMin' },
  { type: 'error', inputs: [], name: 'MaxDurationIsLessThanMin' },
  { type: 'error', inputs: [], name: 'MaxInterestIsLessThanMin' },
  { type: 'error', inputs: [], name: 'MinAmountIsZero' },
  { type: 'error', inputs: [], name: 'MinDurationIsZero' },
  { type: 'error', inputs: [], name: 'MinInterestIsZero' },
  { type: 'error', inputs: [], name: 'NewOwnerIsZeroAddress' },
  { type: 'error', inputs: [], name: 'NoHandoverRequest' },
  { type: 'error', inputs: [], name: 'ObligationNotesIsZeroAddr' },
  { type: 'error', inputs: [], name: 'PlatformWalletIsZeroAddr' },
  {
    type: 'error',
    inputs: [{ name: 'token', internalType: 'address', type: 'address' }],
    name: 'SafeERC20FailedOperation',
  },
  { type: 'error', inputs: [], name: 'Unauthorized' },
  { type: 'error', inputs: [], name: 'UnsupportedNFTCollection' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'loanId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'DefaultedLoanLiquidated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'lendingDeskId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountDeposited',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'LendingDeskLiquidityDeposited',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'lendingDeskId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountWithdrawn',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'LendingDeskLiquidityWithdrawn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'lendingDeskId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'nftCollection',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'LendingDeskLoanConfigRemoved',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'lendingDeskId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'loanConfigs',
        internalType: 'struct IMagnifyCashV1.LoanConfig[]',
        type: 'tuple[]',
        components: [
          { name: 'nftCollection', internalType: 'address', type: 'address' },
          {
            name: 'nftCollectionIsErc1155',
            internalType: 'bool',
            type: 'bool',
          },
          { name: 'minAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'maxAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'minInterest', internalType: 'uint32', type: 'uint32' },
          { name: 'maxInterest', internalType: 'uint32', type: 'uint32' },
          { name: 'minDuration', internalType: 'uint32', type: 'uint32' },
          { name: 'maxDuration', internalType: 'uint32', type: 'uint32' },
        ],
        indexed: false,
      },
    ],
    name: 'LendingDeskLoanConfigsSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'lendingDeskId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'freeze', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'LendingDeskStateSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'loanOriginationFee',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'LoanOriginationFeeSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'loanId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountPaid',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'resolved', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'LoanPaymentMade',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'lendingDeskId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'erc20',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'initialBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'loanConfigs',
        internalType: 'struct IMagnifyCashV1.LoanConfig[]',
        type: 'tuple[]',
        components: [
          { name: 'nftCollection', internalType: 'address', type: 'address' },
          {
            name: 'nftCollectionIsErc1155',
            internalType: 'bool',
            type: 'bool',
          },
          { name: 'minAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'maxAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'minInterest', internalType: 'uint32', type: 'uint32' },
          { name: 'maxInterest', internalType: 'uint32', type: 'uint32' },
          { name: 'minDuration', internalType: 'uint32', type: 'uint32' },
          { name: 'maxDuration', internalType: 'uint32', type: 'uint32' },
        ],
        indexed: false,
      },
    ],
    name: 'NewLendingDeskInitialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'lendingDeskId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'loanId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'borrower',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'nftCollection',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'nftId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'duration',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'interest',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'platformFee',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'NewLoanInitialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'pendingOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipHandoverCanceled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'pendingOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipHandoverRequested',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'Paused',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'platformWallet',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'PlatformWalletSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'obligationNotes',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'lendingKeys',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'ProtocolInitialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'Unpaused',
  },
  {
    type: 'function',
    inputs: [],
    name: 'cancelOwnershipHandover',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'pendingOwner', internalType: 'address', type: 'address' },
    ],
    name: 'completeOwnershipHandover',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_lendingDeskId', internalType: 'uint256', type: 'uint256' },
      { name: '_amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'depositLendingDeskLiquidity',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_loanId', internalType: 'uint256', type: 'uint256' }],
    name: 'getLoanAmountDue',
    outputs: [{ name: 'amount', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_erc20', internalType: 'address', type: 'address' },
      { name: '_depositAmount', internalType: 'uint256', type: 'uint256' },
      {
        name: '_loanConfigs',
        internalType: 'struct IMagnifyCashV1.LoanConfig[]',
        type: 'tuple[]',
        components: [
          { name: 'nftCollection', internalType: 'address', type: 'address' },
          {
            name: 'nftCollectionIsErc1155',
            internalType: 'bool',
            type: 'bool',
          },
          { name: 'minAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'maxAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'minInterest', internalType: 'uint32', type: 'uint32' },
          { name: 'maxInterest', internalType: 'uint32', type: 'uint32' },
          { name: 'minDuration', internalType: 'uint32', type: 'uint32' },
          { name: 'maxDuration', internalType: 'uint32', type: 'uint32' },
        ],
      },
    ],
    name: 'initializeNewLendingDesk',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_lendingDeskId', internalType: 'uint64', type: 'uint64' },
      { name: '_nftCollection', internalType: 'address', type: 'address' },
      { name: '_nftId', internalType: 'uint256', type: 'uint256' },
      { name: '_duration', internalType: 'uint32', type: 'uint32' },
      { name: '_amount', internalType: 'uint256', type: 'uint256' },
      { name: '_maxInterestAllowed', internalType: 'uint32', type: 'uint32' },
    ],
    name: 'initializeNewLoan',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'lendingDeskIdCounter',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'lendingDeskLoanConfigs',
    outputs: [
      { name: 'nftCollection', internalType: 'address', type: 'address' },
      { name: 'nftCollectionIsErc1155', internalType: 'bool', type: 'bool' },
      { name: 'minAmount', internalType: 'uint256', type: 'uint256' },
      { name: 'maxAmount', internalType: 'uint256', type: 'uint256' },
      { name: 'minInterest', internalType: 'uint32', type: 'uint32' },
      { name: 'maxInterest', internalType: 'uint32', type: 'uint32' },
      { name: 'minDuration', internalType: 'uint32', type: 'uint32' },
      { name: 'maxDuration', internalType: 'uint32', type: 'uint32' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    name: 'lendingDesks',
    outputs: [
      { name: 'erc20', internalType: 'address', type: 'address' },
      { name: 'balance', internalType: 'uint256', type: 'uint256' },
      {
        name: 'status',
        internalType: 'enum IMagnifyCashV1.LendingDeskStatus',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'lendingKeys',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_loanId', internalType: 'uint256', type: 'uint256' }],
    name: 'liquidateDefaultedLoan',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'loanIdCounter',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'loanOriginationFee',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    name: 'loans',
    outputs: [
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'amountPaidBack', internalType: 'uint256', type: 'uint256' },
      { name: 'nftCollection', internalType: 'address', type: 'address' },
      { name: 'startTime', internalType: 'uint64', type: 'uint64' },
      { name: 'nftId', internalType: 'uint256', type: 'uint256' },
      { name: 'lendingDeskId', internalType: 'uint64', type: 'uint64' },
      { name: 'duration', internalType: 'uint32', type: 'uint32' },
      { name: 'interest', internalType: 'uint32', type: 'uint32' },
      {
        name: 'status',
        internalType: 'enum IMagnifyCashV1.LoanStatus',
        type: 'uint8',
      },
      { name: 'nftCollectionIsErc1155', internalType: 'bool', type: 'bool' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_loanId', internalType: 'uint256', type: 'uint256' },
      { name: '_amount', internalType: 'uint256', type: 'uint256' },
      { name: '_resolve', internalType: 'bool', type: 'bool' },
    ],
    name: 'makeLoanPayment',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'obligationNotes',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256[]', type: 'uint256[]' },
      { name: '', internalType: 'uint256[]', type: 'uint256[]' },
      { name: '', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'onERC1155BatchReceived',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'onERC1155Received',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'onERC721Received',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: 'result', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'pendingOwner', internalType: 'address', type: 'address' },
    ],
    name: 'ownershipHandoverExpiresAt',
    outputs: [{ name: 'result', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'paused',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'platformWallet',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_lendingDeskId', internalType: 'uint256', type: 'uint256' },
      { name: '_nftCollection', internalType: 'address', type: 'address' },
    ],
    name: 'removeLendingDeskLoanConfig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'requestOwnershipHandover',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_lendingDeskId', internalType: 'uint256', type: 'uint256' },
      {
        name: '_loanConfigs',
        internalType: 'struct IMagnifyCashV1.LoanConfig[]',
        type: 'tuple[]',
        components: [
          { name: 'nftCollection', internalType: 'address', type: 'address' },
          {
            name: 'nftCollectionIsErc1155',
            internalType: 'bool',
            type: 'bool',
          },
          { name: 'minAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'maxAmount', internalType: 'uint256', type: 'uint256' },
          { name: 'minInterest', internalType: 'uint32', type: 'uint32' },
          { name: 'maxInterest', internalType: 'uint32', type: 'uint32' },
          { name: 'minDuration', internalType: 'uint32', type: 'uint32' },
          { name: 'maxDuration', internalType: 'uint32', type: 'uint32' },
        ],
      },
    ],
    name: 'setLendingDeskLoanConfigs',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_lendingDeskId', internalType: 'uint256', type: 'uint256' },
      { name: '_freeze', internalType: 'bool', type: 'bool' },
    ],
    name: 'setLendingDeskState',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_loanOriginationFee', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setLoanOriginationFee',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_paused', internalType: 'bool', type: 'bool' }],
    name: 'setPaused',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_platformWallet', internalType: 'address', type: 'address' },
    ],
    name: 'setPlatformWallet',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_lendingDeskId', internalType: 'uint256', type: 'uint256' },
      { name: '_amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'withdrawLendingDeskLiquidity',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const magnifyCashV1Address = {
  1: '0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a',
  8453: '0x9C8D226016492a8fE6531Fe1409aD79099Dd0729',
  31337: '0x781EBE3865b0911D6989854dCD29DF3cd81168eB',
  84532: '0x781EBE3865b0911D6989854dCD29DF3cd81168eB',
  11155111: '0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4',
} as const

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const magnifyCashV1Config = {
  address: magnifyCashV1Address,
  abi: magnifyCashV1Abi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// MagnifyERC721V1
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const magnifyErc721V1Abi = [
  {
    type: 'constructor',
    inputs: [
      { name: 'name', internalType: 'string', type: 'string' },
      { name: 'symbol', internalType: 'string', type: 'string' },
      { name: '_baseURI', internalType: 'string', type: 'string' },
      { name: 'initialOwner', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  { type: 'error', inputs: [], name: 'AccountBalanceOverflow' },
  { type: 'error', inputs: [], name: 'AlreadyInitialized' },
  { type: 'error', inputs: [], name: 'BalanceQueryForZeroAddress' },
  { type: 'error', inputs: [], name: 'BaseURIIsEmpty' },
  { type: 'error', inputs: [], name: 'CallerIsNotMagnifyCash' },
  { type: 'error', inputs: [], name: 'MagnifyCashIsZeroAddress' },
  { type: 'error', inputs: [], name: 'MintToZeroAddress' },
  { type: 'error', inputs: [], name: 'NameIsEmpty' },
  { type: 'error', inputs: [], name: 'NewOwnerIsZeroAddress' },
  { type: 'error', inputs: [], name: 'NoHandoverRequest' },
  { type: 'error', inputs: [], name: 'NotOwnerNorApproved' },
  { type: 'error', inputs: [], name: 'SymbolIsEmpty' },
  { type: 'error', inputs: [], name: 'TokenAlreadyExists' },
  { type: 'error', inputs: [], name: 'TokenDoesNotExist' },
  { type: 'error', inputs: [], name: 'TransferFromIncorrectOwner' },
  { type: 'error', inputs: [], name: 'TransferToNonERC721ReceiverImplementer' },
  { type: 'error', inputs: [], name: 'TransferToZeroAddress' },
  { type: 'error', inputs: [], name: 'Unauthorized' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: true },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'isApproved',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'ApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'baseURI',
        internalType: 'string',
        type: 'string',
        indexed: true,
      },
    ],
    name: 'BaseURISet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      { name: 'name', internalType: 'string', type: 'string', indexed: false },
      {
        name: 'symbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'baseURI',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'magnifyCash',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'MagnifyCashSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'pendingOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipHandoverCanceled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'pendingOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipHandoverRequested',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: true },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: 'result', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'baseURI',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'cancelOwnershipHandover',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'pendingOwner', internalType: 'address', type: 'address' },
    ],
    name: 'completeOwnershipHandover',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'id', internalType: 'uint256', type: 'uint256' }],
    name: 'getApproved',
    outputs: [{ name: 'result', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'operator', internalType: 'address', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ name: 'result', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'magnifyCash',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: 'result', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'id', internalType: 'uint256', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ name: 'result', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'pendingOwner', internalType: 'address', type: 'address' },
    ],
    name: 'ownershipHandoverExpiresAt',
    outputs: [{ name: 'result', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'requestOwnershipHandover',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'isApproved', internalType: 'bool', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_baseURI', internalType: 'string', type: 'string' }],
    name: 'setBaseURI',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_magnifyCash', internalType: 'address', type: 'address' },
    ],
    name: 'setMagnifyCash',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: 'result', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'tokenURI',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'payable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// MagnifyLendingKeysV1
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const magnifyLendingKeysV1Abi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_name', internalType: 'string', type: 'string' },
      { name: '_symbol', internalType: 'string', type: 'string' },
      { name: '_baseURI', internalType: 'string', type: 'string' },
      { name: '_initialOwner', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  { type: 'error', inputs: [], name: 'AccountBalanceOverflow' },
  { type: 'error', inputs: [], name: 'AlreadyInitialized' },
  { type: 'error', inputs: [], name: 'BalanceQueryForZeroAddress' },
  { type: 'error', inputs: [], name: 'BaseURIIsEmpty' },
  { type: 'error', inputs: [], name: 'CallerIsNotMagnifyCash' },
  { type: 'error', inputs: [], name: 'MagnifyCashIsZeroAddress' },
  { type: 'error', inputs: [], name: 'MintToZeroAddress' },
  { type: 'error', inputs: [], name: 'NameIsEmpty' },
  { type: 'error', inputs: [], name: 'NewOwnerIsZeroAddress' },
  { type: 'error', inputs: [], name: 'NoHandoverRequest' },
  { type: 'error', inputs: [], name: 'NotOwnerNorApproved' },
  { type: 'error', inputs: [], name: 'SymbolIsEmpty' },
  { type: 'error', inputs: [], name: 'TokenAlreadyExists' },
  { type: 'error', inputs: [], name: 'TokenDoesNotExist' },
  { type: 'error', inputs: [], name: 'TransferFromIncorrectOwner' },
  { type: 'error', inputs: [], name: 'TransferToNonERC721ReceiverImplementer' },
  { type: 'error', inputs: [], name: 'TransferToZeroAddress' },
  { type: 'error', inputs: [], name: 'Unauthorized' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: true },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'isApproved',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'ApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'baseURI',
        internalType: 'string',
        type: 'string',
        indexed: true,
      },
    ],
    name: 'BaseURISet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      { name: 'name', internalType: 'string', type: 'string', indexed: false },
      {
        name: 'symbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'baseURI',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'magnifyCash',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'MagnifyCashSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'pendingOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipHandoverCanceled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'pendingOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipHandoverRequested',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: true },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: 'result', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'baseURI',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'cancelOwnershipHandover',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'pendingOwner', internalType: 'address', type: 'address' },
    ],
    name: 'completeOwnershipHandover',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'id', internalType: 'uint256', type: 'uint256' }],
    name: 'getApproved',
    outputs: [{ name: 'result', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'operator', internalType: 'address', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ name: 'result', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'magnifyCash',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: 'result', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'id', internalType: 'uint256', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ name: 'result', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'pendingOwner', internalType: 'address', type: 'address' },
    ],
    name: 'ownershipHandoverExpiresAt',
    outputs: [{ name: 'result', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'requestOwnershipHandover',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'isApproved', internalType: 'bool', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_baseURI', internalType: 'string', type: 'string' }],
    name: 'setBaseURI',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_magnifyCash', internalType: 'address', type: 'address' },
    ],
    name: 'setMagnifyCash',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: 'result', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'tokenURI',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'payable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// MagnifyObligationNotesV1
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const magnifyObligationNotesV1Abi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_name', internalType: 'string', type: 'string' },
      { name: '_symbol', internalType: 'string', type: 'string' },
      { name: '_baseURI', internalType: 'string', type: 'string' },
      { name: '_initialOwner', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  { type: 'error', inputs: [], name: 'AccountBalanceOverflow' },
  { type: 'error', inputs: [], name: 'AlreadyInitialized' },
  { type: 'error', inputs: [], name: 'BalanceQueryForZeroAddress' },
  { type: 'error', inputs: [], name: 'BaseURIIsEmpty' },
  { type: 'error', inputs: [], name: 'CallerIsNotMagnifyCash' },
  { type: 'error', inputs: [], name: 'MagnifyCashIsZeroAddress' },
  { type: 'error', inputs: [], name: 'MintToZeroAddress' },
  { type: 'error', inputs: [], name: 'NameIsEmpty' },
  { type: 'error', inputs: [], name: 'NewOwnerIsZeroAddress' },
  { type: 'error', inputs: [], name: 'NoHandoverRequest' },
  { type: 'error', inputs: [], name: 'NotOwnerNorApproved' },
  { type: 'error', inputs: [], name: 'SymbolIsEmpty' },
  { type: 'error', inputs: [], name: 'TokenAlreadyExists' },
  { type: 'error', inputs: [], name: 'TokenDoesNotExist' },
  { type: 'error', inputs: [], name: 'TransferFromIncorrectOwner' },
  { type: 'error', inputs: [], name: 'TransferToNonERC721ReceiverImplementer' },
  { type: 'error', inputs: [], name: 'TransferToZeroAddress' },
  { type: 'error', inputs: [], name: 'Unauthorized' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: true },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'isApproved',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'ApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'baseURI',
        internalType: 'string',
        type: 'string',
        indexed: true,
      },
    ],
    name: 'BaseURISet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      { name: 'name', internalType: 'string', type: 'string', indexed: false },
      {
        name: 'symbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'baseURI',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'magnifyCash',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'MagnifyCashSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'pendingOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipHandoverCanceled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'pendingOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipHandoverRequested',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: true },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: 'result', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'baseURI',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'cancelOwnershipHandover',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'pendingOwner', internalType: 'address', type: 'address' },
    ],
    name: 'completeOwnershipHandover',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'id', internalType: 'uint256', type: 'uint256' }],
    name: 'getApproved',
    outputs: [{ name: 'result', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'operator', internalType: 'address', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ name: 'result', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'magnifyCash',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: 'result', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'id', internalType: 'uint256', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ name: 'result', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'pendingOwner', internalType: 'address', type: 'address' },
    ],
    name: 'ownershipHandoverExpiresAt',
    outputs: [{ name: 'result', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'requestOwnershipHandover',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'isApproved', internalType: 'bool', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_baseURI', internalType: 'string', type: 'string' }],
    name: 'setBaseURI',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_magnifyCash', internalType: 'address', type: 'address' },
    ],
    name: 'setMagnifyCash',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: 'result', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'tokenURI',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'payable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Math
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const mathAbi = [
  { type: 'error', inputs: [], name: 'MathOverflowedMulDiv' },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Ownable
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ownableAbi = [
  { type: 'error', inputs: [], name: 'AlreadyInitialized' },
  { type: 'error', inputs: [], name: 'NewOwnerIsZeroAddress' },
  { type: 'error', inputs: [], name: 'NoHandoverRequest' },
  { type: 'error', inputs: [], name: 'Unauthorized' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'pendingOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipHandoverCanceled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'pendingOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipHandoverRequested',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'function',
    inputs: [],
    name: 'cancelOwnershipHandover',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'pendingOwner', internalType: 'address', type: 'address' },
    ],
    name: 'completeOwnershipHandover',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: 'result', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'pendingOwner', internalType: 'address', type: 'address' },
    ],
    name: 'ownershipHandoverExpiresAt',
    outputs: [{ name: 'result', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'requestOwnershipHandover',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'payable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Pausable
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const pausableAbi = [
  { type: 'error', inputs: [], name: 'EnforcedPause' },
  { type: 'error', inputs: [], name: 'ExpectedPause' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'Paused',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'Unpaused',
  },
  {
    type: 'function',
    inputs: [],
    name: 'paused',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SafeCastLib
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const safeCastLibAbi = [
  { type: 'error', inputs: [], name: 'Overflow' },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SafeERC20
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const safeErc20Abi = [
  {
    type: 'error',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'currentAllowance', internalType: 'uint256', type: 'uint256' },
      { name: 'requestedDecrease', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'SafeERC20FailedDecreaseAllowance',
  },
  {
    type: 'error',
    inputs: [{ name: 'token', internalType: 'address', type: 'address' }],
    name: 'SafeERC20FailedOperation',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TestERC1155
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const testErc1155Abi = [
  {
    type: 'constructor',
    inputs: [{ name: 'baseURI', internalType: 'string', type: 'string' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'error',
    inputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'balance', internalType: 'uint256', type: 'uint256' },
      { name: 'needed', internalType: 'uint256', type: 'uint256' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ERC1155InsufficientBalance',
  },
  {
    type: 'error',
    inputs: [{ name: 'approver', internalType: 'address', type: 'address' }],
    name: 'ERC1155InvalidApprover',
  },
  {
    type: 'error',
    inputs: [
      { name: 'idsLength', internalType: 'uint256', type: 'uint256' },
      { name: 'valuesLength', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ERC1155InvalidArrayLength',
  },
  {
    type: 'error',
    inputs: [{ name: 'operator', internalType: 'address', type: 'address' }],
    name: 'ERC1155InvalidOperator',
  },
  {
    type: 'error',
    inputs: [{ name: 'receiver', internalType: 'address', type: 'address' }],
    name: 'ERC1155InvalidReceiver',
  },
  {
    type: 'error',
    inputs: [{ name: 'sender', internalType: 'address', type: 'address' }],
    name: 'ERC1155InvalidSender',
  },
  {
    type: 'error',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'owner', internalType: 'address', type: 'address' },
    ],
    name: 'ERC1155MissingApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'approved', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'ids',
        internalType: 'uint256[]',
        type: 'uint256[]',
        indexed: false,
      },
      {
        name: 'values',
        internalType: 'uint256[]',
        type: 'uint256[]',
        indexed: false,
      },
    ],
    name: 'TransferBatch',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: false },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'TransferSingle',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'value', internalType: 'string', type: 'string', indexed: false },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: true },
    ],
    name: 'URI',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'accounts', internalType: 'address[]', type: 'address[]' },
      { name: 'ids', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    name: 'balanceOfBatch',
    outputs: [{ name: '', internalType: 'uint256[]', type: 'uint256[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'operator', internalType: 'address', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'mint',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'ids', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'amounts', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'mintBatch',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'ids', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'values', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeBatchTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'approved', internalType: 'bool', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    name: 'uri',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TestERC20
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const testErc20Abi = [
  {
    type: 'constructor',
    inputs: [
      { name: 'name', internalType: 'string', type: 'string' },
      { name: 'symbol', internalType: 'string', type: 'string' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'error',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'allowance', internalType: 'uint256', type: 'uint256' },
      { name: 'needed', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ERC20InsufficientAllowance',
  },
  {
    type: 'error',
    inputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'balance', internalType: 'uint256', type: 'uint256' },
      { name: 'needed', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ERC20InsufficientBalance',
  },
  {
    type: 'error',
    inputs: [{ name: 'approver', internalType: 'address', type: 'address' }],
    name: 'ERC20InvalidApprover',
  },
  {
    type: 'error',
    inputs: [{ name: 'receiver', internalType: 'address', type: 'address' }],
    name: 'ERC20InvalidReceiver',
  },
  {
    type: 'error',
    inputs: [{ name: 'sender', internalType: 'address', type: 'address' }],
    name: 'ERC20InvalidSender',
  },
  {
    type: 'error',
    inputs: [{ name: 'spender', internalType: 'address', type: 'address' }],
    name: 'ERC20InvalidSpender',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'amount', internalType: 'uint256', type: 'uint256' }],
    name: 'mint',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TestERC721
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const testErc721Abi = [
  {
    type: 'constructor',
    inputs: [
      { name: 'name', internalType: 'string', type: 'string' },
      { name: 'symbol', internalType: 'string', type: 'string' },
      { name: '_baseURI', internalType: 'string', type: 'string' },
    ],
    stateMutability: 'nonpayable',
  },
  { type: 'error', inputs: [], name: 'ApprovalCallerNotOwnerNorApproved' },
  { type: 'error', inputs: [], name: 'ApprovalQueryForNonexistentToken' },
  { type: 'error', inputs: [], name: 'BalanceQueryForZeroAddress' },
  { type: 'error', inputs: [], name: 'MintERC2309QuantityExceedsLimit' },
  { type: 'error', inputs: [], name: 'MintToZeroAddress' },
  { type: 'error', inputs: [], name: 'MintZeroQuantity' },
  { type: 'error', inputs: [], name: 'NotCompatibleWithSpotMints' },
  { type: 'error', inputs: [], name: 'OwnerQueryForNonexistentToken' },
  { type: 'error', inputs: [], name: 'OwnershipNotInitializedForExtraData' },
  { type: 'error', inputs: [], name: 'SequentialMintExceedsLimit' },
  { type: 'error', inputs: [], name: 'SequentialUpToTooSmall' },
  { type: 'error', inputs: [], name: 'SpotMintTokenIdTooSmall' },
  { type: 'error', inputs: [], name: 'TokenAlreadyExists' },
  { type: 'error', inputs: [], name: 'TransferCallerNotOwnerNorApproved' },
  { type: 'error', inputs: [], name: 'TransferFromIncorrectOwner' },
  { type: 'error', inputs: [], name: 'TransferToNonERC721ReceiverImplementer' },
  { type: 'error', inputs: [], name: 'TransferToZeroAddress' },
  { type: 'error', inputs: [], name: 'URIQueryForNonexistentToken' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'approved',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'approved', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fromTokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'toTokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
    ],
    name: 'ConsecutiveTransfer',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'baseURI',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'getApproved',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'operator', internalType: 'address', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'quantity', internalType: 'uint256', type: 'uint256' }],
    name: 'mint',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
      { name: '_data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'approved', internalType: 'bool', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'tokenURI',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: 'result', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'payable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// React
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc1155Abi}__
 */
export const useReadErc1155 = /*#__PURE__*/ createUseReadContract({
  abi: erc1155Abi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc1155Abi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadErc1155BalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: erc1155Abi,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc1155Abi}__ and `functionName` set to `"balanceOfBatch"`
 */
export const useReadErc1155BalanceOfBatch = /*#__PURE__*/ createUseReadContract(
  { abi: erc1155Abi, functionName: 'balanceOfBatch' },
)

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc1155Abi}__ and `functionName` set to `"isApprovedForAll"`
 */
export const useReadErc1155IsApprovedForAll =
  /*#__PURE__*/ createUseReadContract({
    abi: erc1155Abi,
    functionName: 'isApprovedForAll',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc1155Abi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadErc1155SupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: erc1155Abi,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc1155Abi}__ and `functionName` set to `"uri"`
 */
export const useReadErc1155Uri = /*#__PURE__*/ createUseReadContract({
  abi: erc1155Abi,
  functionName: 'uri',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc1155Abi}__
 */
export const useWriteErc1155 = /*#__PURE__*/ createUseWriteContract({
  abi: erc1155Abi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc1155Abi}__ and `functionName` set to `"safeBatchTransferFrom"`
 */
export const useWriteErc1155SafeBatchTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: erc1155Abi,
    functionName: 'safeBatchTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc1155Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useWriteErc1155SafeTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: erc1155Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc1155Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useWriteErc1155SetApprovalForAll =
  /*#__PURE__*/ createUseWriteContract({
    abi: erc1155Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc1155Abi}__
 */
export const useSimulateErc1155 = /*#__PURE__*/ createUseSimulateContract({
  abi: erc1155Abi,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc1155Abi}__ and `functionName` set to `"safeBatchTransferFrom"`
 */
export const useSimulateErc1155SafeBatchTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc1155Abi,
    functionName: 'safeBatchTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc1155Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useSimulateErc1155SafeTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc1155Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc1155Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useSimulateErc1155SetApprovalForAll =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc1155Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc1155Abi}__
 */
export const useWatchErc1155Event = /*#__PURE__*/ createUseWatchContractEvent({
  abi: erc1155Abi,
})

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc1155Abi}__ and `eventName` set to `"ApprovalForAll"`
 */
export const useWatchErc1155ApprovalForAllEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: erc1155Abi,
    eventName: 'ApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc1155Abi}__ and `eventName` set to `"TransferBatch"`
 */
export const useWatchErc1155TransferBatchEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: erc1155Abi,
    eventName: 'TransferBatch',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc1155Abi}__ and `eventName` set to `"TransferSingle"`
 */
export const useWatchErc1155TransferSingleEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: erc1155Abi,
    eventName: 'TransferSingle',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc1155Abi}__ and `eventName` set to `"URI"`
 */
export const useWatchErc1155UriEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: erc1155Abi,
    eventName: 'URI',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc1155HolderAbi}__
 */
export const useReadErc1155Holder = /*#__PURE__*/ createUseReadContract({
  abi: erc1155HolderAbi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc1155HolderAbi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadErc1155HolderSupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: erc1155HolderAbi,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc1155HolderAbi}__
 */
export const useWriteErc1155Holder = /*#__PURE__*/ createUseWriteContract({
  abi: erc1155HolderAbi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc1155HolderAbi}__ and `functionName` set to `"onERC1155BatchReceived"`
 */
export const useWriteErc1155HolderOnErc1155BatchReceived =
  /*#__PURE__*/ createUseWriteContract({
    abi: erc1155HolderAbi,
    functionName: 'onERC1155BatchReceived',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc1155HolderAbi}__ and `functionName` set to `"onERC1155Received"`
 */
export const useWriteErc1155HolderOnErc1155Received =
  /*#__PURE__*/ createUseWriteContract({
    abi: erc1155HolderAbi,
    functionName: 'onERC1155Received',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc1155HolderAbi}__
 */
export const useSimulateErc1155Holder = /*#__PURE__*/ createUseSimulateContract(
  { abi: erc1155HolderAbi },
)

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc1155HolderAbi}__ and `functionName` set to `"onERC1155BatchReceived"`
 */
export const useSimulateErc1155HolderOnErc1155BatchReceived =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc1155HolderAbi,
    functionName: 'onERC1155BatchReceived',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc1155HolderAbi}__ and `functionName` set to `"onERC1155Received"`
 */
export const useSimulateErc1155HolderOnErc1155Received =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc1155HolderAbi,
    functionName: 'onERC1155Received',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc165Abi}__
 */
export const useReadErc165 = /*#__PURE__*/ createUseReadContract({
  abi: erc165Abi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc165Abi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadErc165SupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: erc165Abi,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20Abi}__
 */
export const useReadErc20 = /*#__PURE__*/ createUseReadContract({
  abi: erc20Abi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"allowance"`
 */
export const useReadErc20Allowance = /*#__PURE__*/ createUseReadContract({
  abi: erc20Abi,
  functionName: 'allowance',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadErc20BalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: erc20Abi,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"decimals"`
 */
export const useReadErc20Decimals = /*#__PURE__*/ createUseReadContract({
  abi: erc20Abi,
  functionName: 'decimals',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"name"`
 */
export const useReadErc20Name = /*#__PURE__*/ createUseReadContract({
  abi: erc20Abi,
  functionName: 'name',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"symbol"`
 */
export const useReadErc20Symbol = /*#__PURE__*/ createUseReadContract({
  abi: erc20Abi,
  functionName: 'symbol',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"totalSupply"`
 */
export const useReadErc20TotalSupply = /*#__PURE__*/ createUseReadContract({
  abi: erc20Abi,
  functionName: 'totalSupply',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc20Abi}__
 */
export const useWriteErc20 = /*#__PURE__*/ createUseWriteContract({
  abi: erc20Abi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"approve"`
 */
export const useWriteErc20Approve = /*#__PURE__*/ createUseWriteContract({
  abi: erc20Abi,
  functionName: 'approve',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"transfer"`
 */
export const useWriteErc20Transfer = /*#__PURE__*/ createUseWriteContract({
  abi: erc20Abi,
  functionName: 'transfer',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteErc20TransferFrom = /*#__PURE__*/ createUseWriteContract({
  abi: erc20Abi,
  functionName: 'transferFrom',
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc20Abi}__
 */
export const useSimulateErc20 = /*#__PURE__*/ createUseSimulateContract({
  abi: erc20Abi,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"approve"`
 */
export const useSimulateErc20Approve = /*#__PURE__*/ createUseSimulateContract({
  abi: erc20Abi,
  functionName: 'approve',
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"transfer"`
 */
export const useSimulateErc20Transfer = /*#__PURE__*/ createUseSimulateContract(
  { abi: erc20Abi, functionName: 'transfer' },
)

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateErc20TransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc20Abi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc20Abi}__
 */
export const useWatchErc20Event = /*#__PURE__*/ createUseWatchContractEvent({
  abi: erc20Abi,
})

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc20Abi}__ and `eventName` set to `"Approval"`
 */
export const useWatchErc20ApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: erc20Abi,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc20Abi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchErc20TransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: erc20Abi,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721Abi}__
 */
export const useReadErc721 = /*#__PURE__*/ createUseReadContract({
  abi: erc721Abi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721Abi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadErc721BalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: erc721Abi,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721Abi}__ and `functionName` set to `"getApproved"`
 */
export const useReadErc721GetApproved = /*#__PURE__*/ createUseReadContract({
  abi: erc721Abi,
  functionName: 'getApproved',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721Abi}__ and `functionName` set to `"isApprovedForAll"`
 */
export const useReadErc721IsApprovedForAll =
  /*#__PURE__*/ createUseReadContract({
    abi: erc721Abi,
    functionName: 'isApprovedForAll',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721Abi}__ and `functionName` set to `"name"`
 */
export const useReadErc721Name = /*#__PURE__*/ createUseReadContract({
  abi: erc721Abi,
  functionName: 'name',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721Abi}__ and `functionName` set to `"ownerOf"`
 */
export const useReadErc721OwnerOf = /*#__PURE__*/ createUseReadContract({
  abi: erc721Abi,
  functionName: 'ownerOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721Abi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadErc721SupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: erc721Abi,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721Abi}__ and `functionName` set to `"symbol"`
 */
export const useReadErc721Symbol = /*#__PURE__*/ createUseReadContract({
  abi: erc721Abi,
  functionName: 'symbol',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721Abi}__ and `functionName` set to `"tokenURI"`
 */
export const useReadErc721TokenUri = /*#__PURE__*/ createUseReadContract({
  abi: erc721Abi,
  functionName: 'tokenURI',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc721Abi}__
 */
export const useWriteErc721 = /*#__PURE__*/ createUseWriteContract({
  abi: erc721Abi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc721Abi}__ and `functionName` set to `"approve"`
 */
export const useWriteErc721Approve = /*#__PURE__*/ createUseWriteContract({
  abi: erc721Abi,
  functionName: 'approve',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc721Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useWriteErc721SafeTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: erc721Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc721Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useWriteErc721SetApprovalForAll =
  /*#__PURE__*/ createUseWriteContract({
    abi: erc721Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc721Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteErc721TransferFrom = /*#__PURE__*/ createUseWriteContract({
  abi: erc721Abi,
  functionName: 'transferFrom',
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc721Abi}__
 */
export const useSimulateErc721 = /*#__PURE__*/ createUseSimulateContract({
  abi: erc721Abi,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc721Abi}__ and `functionName` set to `"approve"`
 */
export const useSimulateErc721Approve = /*#__PURE__*/ createUseSimulateContract(
  { abi: erc721Abi, functionName: 'approve' },
)

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc721Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useSimulateErc721SafeTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc721Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc721Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useSimulateErc721SetApprovalForAll =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc721Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc721Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateErc721TransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc721Abi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc721Abi}__
 */
export const useWatchErc721Event = /*#__PURE__*/ createUseWatchContractEvent({
  abi: erc721Abi,
})

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc721Abi}__ and `eventName` set to `"Approval"`
 */
export const useWatchErc721ApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: erc721Abi,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc721Abi}__ and `eventName` set to `"ApprovalForAll"`
 */
export const useWatchErc721ApprovalForAllEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: erc721Abi,
    eventName: 'ApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc721Abi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchErc721TransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: erc721Abi,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721AAbi}__
 */
export const useReadErc721A = /*#__PURE__*/ createUseReadContract({
  abi: erc721AAbi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721AAbi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadErc721ABalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: erc721AAbi,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721AAbi}__ and `functionName` set to `"getApproved"`
 */
export const useReadErc721AGetApproved = /*#__PURE__*/ createUseReadContract({
  abi: erc721AAbi,
  functionName: 'getApproved',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721AAbi}__ and `functionName` set to `"isApprovedForAll"`
 */
export const useReadErc721AIsApprovedForAll =
  /*#__PURE__*/ createUseReadContract({
    abi: erc721AAbi,
    functionName: 'isApprovedForAll',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721AAbi}__ and `functionName` set to `"name"`
 */
export const useReadErc721AName = /*#__PURE__*/ createUseReadContract({
  abi: erc721AAbi,
  functionName: 'name',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721AAbi}__ and `functionName` set to `"ownerOf"`
 */
export const useReadErc721AOwnerOf = /*#__PURE__*/ createUseReadContract({
  abi: erc721AAbi,
  functionName: 'ownerOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721AAbi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadErc721ASupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: erc721AAbi,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721AAbi}__ and `functionName` set to `"symbol"`
 */
export const useReadErc721ASymbol = /*#__PURE__*/ createUseReadContract({
  abi: erc721AAbi,
  functionName: 'symbol',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721AAbi}__ and `functionName` set to `"tokenURI"`
 */
export const useReadErc721ATokenUri = /*#__PURE__*/ createUseReadContract({
  abi: erc721AAbi,
  functionName: 'tokenURI',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc721AAbi}__ and `functionName` set to `"totalSupply"`
 */
export const useReadErc721ATotalSupply = /*#__PURE__*/ createUseReadContract({
  abi: erc721AAbi,
  functionName: 'totalSupply',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc721AAbi}__
 */
export const useWriteErc721A = /*#__PURE__*/ createUseWriteContract({
  abi: erc721AAbi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc721AAbi}__ and `functionName` set to `"approve"`
 */
export const useWriteErc721AApprove = /*#__PURE__*/ createUseWriteContract({
  abi: erc721AAbi,
  functionName: 'approve',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc721AAbi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useWriteErc721ASafeTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: erc721AAbi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc721AAbi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useWriteErc721ASetApprovalForAll =
  /*#__PURE__*/ createUseWriteContract({
    abi: erc721AAbi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc721AAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteErc721ATransferFrom = /*#__PURE__*/ createUseWriteContract(
  { abi: erc721AAbi, functionName: 'transferFrom' },
)

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc721AAbi}__
 */
export const useSimulateErc721A = /*#__PURE__*/ createUseSimulateContract({
  abi: erc721AAbi,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc721AAbi}__ and `functionName` set to `"approve"`
 */
export const useSimulateErc721AApprove =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc721AAbi,
    functionName: 'approve',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc721AAbi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useSimulateErc721ASafeTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc721AAbi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc721AAbi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useSimulateErc721ASetApprovalForAll =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc721AAbi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc721AAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateErc721ATransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc721AAbi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc721AAbi}__
 */
export const useWatchErc721AEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: erc721AAbi,
})

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc721AAbi}__ and `eventName` set to `"Approval"`
 */
export const useWatchErc721AApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: erc721AAbi,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc721AAbi}__ and `eventName` set to `"ApprovalForAll"`
 */
export const useWatchErc721AApprovalForAllEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: erc721AAbi,
    eventName: 'ApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc721AAbi}__ and `eventName` set to `"ConsecutiveTransfer"`
 */
export const useWatchErc721AConsecutiveTransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: erc721AAbi,
    eventName: 'ConsecutiveTransfer',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc721AAbi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchErc721ATransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: erc721AAbi,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc721AIerc721ReceiverAbi}__
 */
export const useWriteErc721AIerc721Receiver =
  /*#__PURE__*/ createUseWriteContract({ abi: erc721AIerc721ReceiverAbi })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc721AIerc721ReceiverAbi}__ and `functionName` set to `"onERC721Received"`
 */
export const useWriteErc721AIerc721ReceiverOnErc721Received =
  /*#__PURE__*/ createUseWriteContract({
    abi: erc721AIerc721ReceiverAbi,
    functionName: 'onERC721Received',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc721AIerc721ReceiverAbi}__
 */
export const useSimulateErc721AIerc721Receiver =
  /*#__PURE__*/ createUseSimulateContract({ abi: erc721AIerc721ReceiverAbi })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc721AIerc721ReceiverAbi}__ and `functionName` set to `"onERC721Received"`
 */
export const useSimulateErc721AIerc721ReceiverOnErc721Received =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc721AIerc721ReceiverAbi,
    functionName: 'onERC721Received',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc721HolderAbi}__
 */
export const useWriteErc721Holder = /*#__PURE__*/ createUseWriteContract({
  abi: erc721HolderAbi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc721HolderAbi}__ and `functionName` set to `"onERC721Received"`
 */
export const useWriteErc721HolderOnErc721Received =
  /*#__PURE__*/ createUseWriteContract({
    abi: erc721HolderAbi,
    functionName: 'onERC721Received',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc721HolderAbi}__
 */
export const useSimulateErc721Holder = /*#__PURE__*/ createUseSimulateContract({
  abi: erc721HolderAbi,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc721HolderAbi}__ and `functionName` set to `"onERC721Received"`
 */
export const useSimulateErc721HolderOnErc721Received =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc721HolderAbi,
    functionName: 'onERC721Received',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc1155Abi}__
 */
export const useReadIerc1155 = /*#__PURE__*/ createUseReadContract({
  abi: ierc1155Abi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc1155Abi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadIerc1155BalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: ierc1155Abi,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc1155Abi}__ and `functionName` set to `"balanceOfBatch"`
 */
export const useReadIerc1155BalanceOfBatch =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc1155Abi,
    functionName: 'balanceOfBatch',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc1155Abi}__ and `functionName` set to `"isApprovedForAll"`
 */
export const useReadIerc1155IsApprovedForAll =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc1155Abi,
    functionName: 'isApprovedForAll',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc1155Abi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadIerc1155SupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc1155Abi,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc1155Abi}__
 */
export const useWriteIerc1155 = /*#__PURE__*/ createUseWriteContract({
  abi: ierc1155Abi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc1155Abi}__ and `functionName` set to `"safeBatchTransferFrom"`
 */
export const useWriteIerc1155SafeBatchTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: ierc1155Abi,
    functionName: 'safeBatchTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc1155Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useWriteIerc1155SafeTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: ierc1155Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc1155Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useWriteIerc1155SetApprovalForAll =
  /*#__PURE__*/ createUseWriteContract({
    abi: ierc1155Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc1155Abi}__
 */
export const useSimulateIerc1155 = /*#__PURE__*/ createUseSimulateContract({
  abi: ierc1155Abi,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc1155Abi}__ and `functionName` set to `"safeBatchTransferFrom"`
 */
export const useSimulateIerc1155SafeBatchTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc1155Abi,
    functionName: 'safeBatchTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc1155Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useSimulateIerc1155SafeTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc1155Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc1155Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useSimulateIerc1155SetApprovalForAll =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc1155Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc1155Abi}__
 */
export const useWatchIerc1155Event = /*#__PURE__*/ createUseWatchContractEvent({
  abi: ierc1155Abi,
})

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc1155Abi}__ and `eventName` set to `"ApprovalForAll"`
 */
export const useWatchIerc1155ApprovalForAllEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc1155Abi,
    eventName: 'ApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc1155Abi}__ and `eventName` set to `"TransferBatch"`
 */
export const useWatchIerc1155TransferBatchEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc1155Abi,
    eventName: 'TransferBatch',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc1155Abi}__ and `eventName` set to `"TransferSingle"`
 */
export const useWatchIerc1155TransferSingleEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc1155Abi,
    eventName: 'TransferSingle',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc1155Abi}__ and `eventName` set to `"URI"`
 */
export const useWatchIerc1155UriEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc1155Abi,
    eventName: 'URI',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__
 */
export const useReadIerc1155MetadataUri = /*#__PURE__*/ createUseReadContract({
  abi: ierc1155MetadataUriAbi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadIerc1155MetadataUriBalanceOf =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc1155MetadataUriAbi,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__ and `functionName` set to `"balanceOfBatch"`
 */
export const useReadIerc1155MetadataUriBalanceOfBatch =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc1155MetadataUriAbi,
    functionName: 'balanceOfBatch',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__ and `functionName` set to `"isApprovedForAll"`
 */
export const useReadIerc1155MetadataUriIsApprovedForAll =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc1155MetadataUriAbi,
    functionName: 'isApprovedForAll',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadIerc1155MetadataUriSupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc1155MetadataUriAbi,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__ and `functionName` set to `"uri"`
 */
export const useReadIerc1155MetadataUriUri =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc1155MetadataUriAbi,
    functionName: 'uri',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__
 */
export const useWriteIerc1155MetadataUri = /*#__PURE__*/ createUseWriteContract(
  { abi: ierc1155MetadataUriAbi },
)

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__ and `functionName` set to `"safeBatchTransferFrom"`
 */
export const useWriteIerc1155MetadataUriSafeBatchTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: ierc1155MetadataUriAbi,
    functionName: 'safeBatchTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useWriteIerc1155MetadataUriSafeTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: ierc1155MetadataUriAbi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useWriteIerc1155MetadataUriSetApprovalForAll =
  /*#__PURE__*/ createUseWriteContract({
    abi: ierc1155MetadataUriAbi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__
 */
export const useSimulateIerc1155MetadataUri =
  /*#__PURE__*/ createUseSimulateContract({ abi: ierc1155MetadataUriAbi })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__ and `functionName` set to `"safeBatchTransferFrom"`
 */
export const useSimulateIerc1155MetadataUriSafeBatchTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc1155MetadataUriAbi,
    functionName: 'safeBatchTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useSimulateIerc1155MetadataUriSafeTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc1155MetadataUriAbi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useSimulateIerc1155MetadataUriSetApprovalForAll =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc1155MetadataUriAbi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__
 */
export const useWatchIerc1155MetadataUriEvent =
  /*#__PURE__*/ createUseWatchContractEvent({ abi: ierc1155MetadataUriAbi })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__ and `eventName` set to `"ApprovalForAll"`
 */
export const useWatchIerc1155MetadataUriApprovalForAllEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc1155MetadataUriAbi,
    eventName: 'ApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__ and `eventName` set to `"TransferBatch"`
 */
export const useWatchIerc1155MetadataUriTransferBatchEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc1155MetadataUriAbi,
    eventName: 'TransferBatch',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__ and `eventName` set to `"TransferSingle"`
 */
export const useWatchIerc1155MetadataUriTransferSingleEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc1155MetadataUriAbi,
    eventName: 'TransferSingle',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc1155MetadataUriAbi}__ and `eventName` set to `"URI"`
 */
export const useWatchIerc1155MetadataUriUriEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc1155MetadataUriAbi,
    eventName: 'URI',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc1155ReceiverAbi}__
 */
export const useReadIerc1155Receiver = /*#__PURE__*/ createUseReadContract({
  abi: ierc1155ReceiverAbi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc1155ReceiverAbi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadIerc1155ReceiverSupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc1155ReceiverAbi,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc1155ReceiverAbi}__
 */
export const useWriteIerc1155Receiver = /*#__PURE__*/ createUseWriteContract({
  abi: ierc1155ReceiverAbi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc1155ReceiverAbi}__ and `functionName` set to `"onERC1155BatchReceived"`
 */
export const useWriteIerc1155ReceiverOnErc1155BatchReceived =
  /*#__PURE__*/ createUseWriteContract({
    abi: ierc1155ReceiverAbi,
    functionName: 'onERC1155BatchReceived',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc1155ReceiverAbi}__ and `functionName` set to `"onERC1155Received"`
 */
export const useWriteIerc1155ReceiverOnErc1155Received =
  /*#__PURE__*/ createUseWriteContract({
    abi: ierc1155ReceiverAbi,
    functionName: 'onERC1155Received',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc1155ReceiverAbi}__
 */
export const useSimulateIerc1155Receiver =
  /*#__PURE__*/ createUseSimulateContract({ abi: ierc1155ReceiverAbi })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc1155ReceiverAbi}__ and `functionName` set to `"onERC1155BatchReceived"`
 */
export const useSimulateIerc1155ReceiverOnErc1155BatchReceived =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc1155ReceiverAbi,
    functionName: 'onERC1155BatchReceived',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc1155ReceiverAbi}__ and `functionName` set to `"onERC1155Received"`
 */
export const useSimulateIerc1155ReceiverOnErc1155Received =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc1155ReceiverAbi,
    functionName: 'onERC1155Received',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc165Abi}__
 */
export const useReadIerc165 = /*#__PURE__*/ createUseReadContract({
  abi: ierc165Abi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc165Abi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadIerc165SupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc165Abi,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc20Abi}__
 */
export const useReadIerc20 = /*#__PURE__*/ createUseReadContract({
  abi: ierc20Abi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc20Abi}__ and `functionName` set to `"allowance"`
 */
export const useReadIerc20Allowance = /*#__PURE__*/ createUseReadContract({
  abi: ierc20Abi,
  functionName: 'allowance',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc20Abi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadIerc20BalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: ierc20Abi,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc20Abi}__ and `functionName` set to `"totalSupply"`
 */
export const useReadIerc20TotalSupply = /*#__PURE__*/ createUseReadContract({
  abi: ierc20Abi,
  functionName: 'totalSupply',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc20Abi}__
 */
export const useWriteIerc20 = /*#__PURE__*/ createUseWriteContract({
  abi: ierc20Abi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc20Abi}__ and `functionName` set to `"approve"`
 */
export const useWriteIerc20Approve = /*#__PURE__*/ createUseWriteContract({
  abi: ierc20Abi,
  functionName: 'approve',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc20Abi}__ and `functionName` set to `"transfer"`
 */
export const useWriteIerc20Transfer = /*#__PURE__*/ createUseWriteContract({
  abi: ierc20Abi,
  functionName: 'transfer',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc20Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteIerc20TransferFrom = /*#__PURE__*/ createUseWriteContract({
  abi: ierc20Abi,
  functionName: 'transferFrom',
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc20Abi}__
 */
export const useSimulateIerc20 = /*#__PURE__*/ createUseSimulateContract({
  abi: ierc20Abi,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc20Abi}__ and `functionName` set to `"approve"`
 */
export const useSimulateIerc20Approve = /*#__PURE__*/ createUseSimulateContract(
  { abi: ierc20Abi, functionName: 'approve' },
)

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc20Abi}__ and `functionName` set to `"transfer"`
 */
export const useSimulateIerc20Transfer =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc20Abi,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc20Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateIerc20TransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc20Abi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc20Abi}__
 */
export const useWatchIerc20Event = /*#__PURE__*/ createUseWatchContractEvent({
  abi: ierc20Abi,
})

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc20Abi}__ and `eventName` set to `"Approval"`
 */
export const useWatchIerc20ApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc20Abi,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc20Abi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchIerc20TransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc20Abi,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc20MetadataAbi}__
 */
export const useReadIerc20Metadata = /*#__PURE__*/ createUseReadContract({
  abi: ierc20MetadataAbi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc20MetadataAbi}__ and `functionName` set to `"allowance"`
 */
export const useReadIerc20MetadataAllowance =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc20MetadataAbi,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc20MetadataAbi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadIerc20MetadataBalanceOf =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc20MetadataAbi,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc20MetadataAbi}__ and `functionName` set to `"decimals"`
 */
export const useReadIerc20MetadataDecimals =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc20MetadataAbi,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc20MetadataAbi}__ and `functionName` set to `"name"`
 */
export const useReadIerc20MetadataName = /*#__PURE__*/ createUseReadContract({
  abi: ierc20MetadataAbi,
  functionName: 'name',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc20MetadataAbi}__ and `functionName` set to `"symbol"`
 */
export const useReadIerc20MetadataSymbol = /*#__PURE__*/ createUseReadContract({
  abi: ierc20MetadataAbi,
  functionName: 'symbol',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc20MetadataAbi}__ and `functionName` set to `"totalSupply"`
 */
export const useReadIerc20MetadataTotalSupply =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc20MetadataAbi,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc20MetadataAbi}__
 */
export const useWriteIerc20Metadata = /*#__PURE__*/ createUseWriteContract({
  abi: ierc20MetadataAbi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc20MetadataAbi}__ and `functionName` set to `"approve"`
 */
export const useWriteIerc20MetadataApprove =
  /*#__PURE__*/ createUseWriteContract({
    abi: ierc20MetadataAbi,
    functionName: 'approve',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc20MetadataAbi}__ and `functionName` set to `"transfer"`
 */
export const useWriteIerc20MetadataTransfer =
  /*#__PURE__*/ createUseWriteContract({
    abi: ierc20MetadataAbi,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc20MetadataAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteIerc20MetadataTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: ierc20MetadataAbi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc20MetadataAbi}__
 */
export const useSimulateIerc20Metadata =
  /*#__PURE__*/ createUseSimulateContract({ abi: ierc20MetadataAbi })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc20MetadataAbi}__ and `functionName` set to `"approve"`
 */
export const useSimulateIerc20MetadataApprove =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc20MetadataAbi,
    functionName: 'approve',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc20MetadataAbi}__ and `functionName` set to `"transfer"`
 */
export const useSimulateIerc20MetadataTransfer =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc20MetadataAbi,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc20MetadataAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateIerc20MetadataTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc20MetadataAbi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc20MetadataAbi}__
 */
export const useWatchIerc20MetadataEvent =
  /*#__PURE__*/ createUseWatchContractEvent({ abi: ierc20MetadataAbi })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc20MetadataAbi}__ and `eventName` set to `"Approval"`
 */
export const useWatchIerc20MetadataApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc20MetadataAbi,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc20MetadataAbi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchIerc20MetadataTransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc20MetadataAbi,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc20PermitAbi}__
 */
export const useReadIerc20Permit = /*#__PURE__*/ createUseReadContract({
  abi: ierc20PermitAbi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc20PermitAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 */
export const useReadIerc20PermitDomainSeparator =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc20PermitAbi,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc20PermitAbi}__ and `functionName` set to `"nonces"`
 */
export const useReadIerc20PermitNonces = /*#__PURE__*/ createUseReadContract({
  abi: ierc20PermitAbi,
  functionName: 'nonces',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc20PermitAbi}__
 */
export const useWriteIerc20Permit = /*#__PURE__*/ createUseWriteContract({
  abi: ierc20PermitAbi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc20PermitAbi}__ and `functionName` set to `"permit"`
 */
export const useWriteIerc20PermitPermit = /*#__PURE__*/ createUseWriteContract({
  abi: ierc20PermitAbi,
  functionName: 'permit',
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc20PermitAbi}__
 */
export const useSimulateIerc20Permit = /*#__PURE__*/ createUseSimulateContract({
  abi: ierc20PermitAbi,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc20PermitAbi}__ and `functionName` set to `"permit"`
 */
export const useSimulateIerc20PermitPermit =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc20PermitAbi,
    functionName: 'permit',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc721Abi}__
 */
export const useReadIerc721 = /*#__PURE__*/ createUseReadContract({
  abi: ierc721Abi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc721Abi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadIerc721BalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: ierc721Abi,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc721Abi}__ and `functionName` set to `"getApproved"`
 */
export const useReadIerc721GetApproved = /*#__PURE__*/ createUseReadContract({
  abi: ierc721Abi,
  functionName: 'getApproved',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc721Abi}__ and `functionName` set to `"isApprovedForAll"`
 */
export const useReadIerc721IsApprovedForAll =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc721Abi,
    functionName: 'isApprovedForAll',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc721Abi}__ and `functionName` set to `"ownerOf"`
 */
export const useReadIerc721OwnerOf = /*#__PURE__*/ createUseReadContract({
  abi: ierc721Abi,
  functionName: 'ownerOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc721Abi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadIerc721SupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc721Abi,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc721Abi}__
 */
export const useWriteIerc721 = /*#__PURE__*/ createUseWriteContract({
  abi: ierc721Abi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc721Abi}__ and `functionName` set to `"approve"`
 */
export const useWriteIerc721Approve = /*#__PURE__*/ createUseWriteContract({
  abi: ierc721Abi,
  functionName: 'approve',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc721Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useWriteIerc721SafeTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: ierc721Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc721Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useWriteIerc721SetApprovalForAll =
  /*#__PURE__*/ createUseWriteContract({
    abi: ierc721Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc721Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteIerc721TransferFrom = /*#__PURE__*/ createUseWriteContract(
  { abi: ierc721Abi, functionName: 'transferFrom' },
)

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc721Abi}__
 */
export const useSimulateIerc721 = /*#__PURE__*/ createUseSimulateContract({
  abi: ierc721Abi,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc721Abi}__ and `functionName` set to `"approve"`
 */
export const useSimulateIerc721Approve =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc721Abi,
    functionName: 'approve',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc721Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useSimulateIerc721SafeTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc721Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc721Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useSimulateIerc721SetApprovalForAll =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc721Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc721Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateIerc721TransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc721Abi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc721Abi}__
 */
export const useWatchIerc721Event = /*#__PURE__*/ createUseWatchContractEvent({
  abi: ierc721Abi,
})

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc721Abi}__ and `eventName` set to `"Approval"`
 */
export const useWatchIerc721ApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc721Abi,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc721Abi}__ and `eventName` set to `"ApprovalForAll"`
 */
export const useWatchIerc721ApprovalForAllEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc721Abi,
    eventName: 'ApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc721Abi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchIerc721TransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc721Abi,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc721AAbi}__
 */
export const useReadIerc721A = /*#__PURE__*/ createUseReadContract({
  abi: ierc721AAbi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc721AAbi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadIerc721ABalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: ierc721AAbi,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc721AAbi}__ and `functionName` set to `"getApproved"`
 */
export const useReadIerc721AGetApproved = /*#__PURE__*/ createUseReadContract({
  abi: ierc721AAbi,
  functionName: 'getApproved',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc721AAbi}__ and `functionName` set to `"isApprovedForAll"`
 */
export const useReadIerc721AIsApprovedForAll =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc721AAbi,
    functionName: 'isApprovedForAll',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc721AAbi}__ and `functionName` set to `"name"`
 */
export const useReadIerc721AName = /*#__PURE__*/ createUseReadContract({
  abi: ierc721AAbi,
  functionName: 'name',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc721AAbi}__ and `functionName` set to `"ownerOf"`
 */
export const useReadIerc721AOwnerOf = /*#__PURE__*/ createUseReadContract({
  abi: ierc721AAbi,
  functionName: 'ownerOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc721AAbi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadIerc721ASupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: ierc721AAbi,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc721AAbi}__ and `functionName` set to `"symbol"`
 */
export const useReadIerc721ASymbol = /*#__PURE__*/ createUseReadContract({
  abi: ierc721AAbi,
  functionName: 'symbol',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc721AAbi}__ and `functionName` set to `"tokenURI"`
 */
export const useReadIerc721ATokenUri = /*#__PURE__*/ createUseReadContract({
  abi: ierc721AAbi,
  functionName: 'tokenURI',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ierc721AAbi}__ and `functionName` set to `"totalSupply"`
 */
export const useReadIerc721ATotalSupply = /*#__PURE__*/ createUseReadContract({
  abi: ierc721AAbi,
  functionName: 'totalSupply',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc721AAbi}__
 */
export const useWriteIerc721A = /*#__PURE__*/ createUseWriteContract({
  abi: ierc721AAbi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc721AAbi}__ and `functionName` set to `"approve"`
 */
export const useWriteIerc721AApprove = /*#__PURE__*/ createUseWriteContract({
  abi: ierc721AAbi,
  functionName: 'approve',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc721AAbi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useWriteIerc721ASafeTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: ierc721AAbi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc721AAbi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useWriteIerc721ASetApprovalForAll =
  /*#__PURE__*/ createUseWriteContract({
    abi: ierc721AAbi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc721AAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteIerc721ATransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: ierc721AAbi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc721AAbi}__
 */
export const useSimulateIerc721A = /*#__PURE__*/ createUseSimulateContract({
  abi: ierc721AAbi,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc721AAbi}__ and `functionName` set to `"approve"`
 */
export const useSimulateIerc721AApprove =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc721AAbi,
    functionName: 'approve',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc721AAbi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useSimulateIerc721ASafeTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc721AAbi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc721AAbi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useSimulateIerc721ASetApprovalForAll =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc721AAbi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc721AAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateIerc721ATransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc721AAbi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc721AAbi}__
 */
export const useWatchIerc721AEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: ierc721AAbi,
})

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc721AAbi}__ and `eventName` set to `"Approval"`
 */
export const useWatchIerc721AApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc721AAbi,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc721AAbi}__ and `eventName` set to `"ApprovalForAll"`
 */
export const useWatchIerc721AApprovalForAllEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc721AAbi,
    eventName: 'ApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc721AAbi}__ and `eventName` set to `"ConsecutiveTransfer"`
 */
export const useWatchIerc721AConsecutiveTransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc721AAbi,
    eventName: 'ConsecutiveTransfer',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ierc721AAbi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchIerc721ATransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ierc721AAbi,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc721ReceiverAbi}__
 */
export const useWriteIerc721Receiver = /*#__PURE__*/ createUseWriteContract({
  abi: ierc721ReceiverAbi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ierc721ReceiverAbi}__ and `functionName` set to `"onERC721Received"`
 */
export const useWriteIerc721ReceiverOnErc721Received =
  /*#__PURE__*/ createUseWriteContract({
    abi: ierc721ReceiverAbi,
    functionName: 'onERC721Received',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc721ReceiverAbi}__
 */
export const useSimulateIerc721Receiver =
  /*#__PURE__*/ createUseSimulateContract({ abi: ierc721ReceiverAbi })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ierc721ReceiverAbi}__ and `functionName` set to `"onERC721Received"`
 */
export const useSimulateIerc721ReceiverOnErc721Received =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ierc721ReceiverAbi,
    functionName: 'onERC721Received',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__
 */
export const useReadIMagnifyCashV1 = /*#__PURE__*/ createUseReadContract({
  abi: iMagnifyCashV1Abi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"getLoanAmountDue"`
 */
export const useReadIMagnifyCashV1GetLoanAmountDue =
  /*#__PURE__*/ createUseReadContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'getLoanAmountDue',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__
 */
export const useWriteIMagnifyCashV1 = /*#__PURE__*/ createUseWriteContract({
  abi: iMagnifyCashV1Abi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"depositLendingDeskLiquidity"`
 */
export const useWriteIMagnifyCashV1DepositLendingDeskLiquidity =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'depositLendingDeskLiquidity',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"initializeNewLendingDesk"`
 */
export const useWriteIMagnifyCashV1InitializeNewLendingDesk =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'initializeNewLendingDesk',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"initializeNewLoan"`
 */
export const useWriteIMagnifyCashV1InitializeNewLoan =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'initializeNewLoan',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"liquidateDefaultedLoan"`
 */
export const useWriteIMagnifyCashV1LiquidateDefaultedLoan =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'liquidateDefaultedLoan',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"makeLoanPayment"`
 */
export const useWriteIMagnifyCashV1MakeLoanPayment =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'makeLoanPayment',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"removeLendingDeskLoanConfig"`
 */
export const useWriteIMagnifyCashV1RemoveLendingDeskLoanConfig =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'removeLendingDeskLoanConfig',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"setLendingDeskLoanConfigs"`
 */
export const useWriteIMagnifyCashV1SetLendingDeskLoanConfigs =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'setLendingDeskLoanConfigs',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"setLendingDeskState"`
 */
export const useWriteIMagnifyCashV1SetLendingDeskState =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'setLendingDeskState',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"setLoanOriginationFee"`
 */
export const useWriteIMagnifyCashV1SetLoanOriginationFee =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'setLoanOriginationFee',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"setPaused"`
 */
export const useWriteIMagnifyCashV1SetPaused =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'setPaused',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"setPlatformWallet"`
 */
export const useWriteIMagnifyCashV1SetPlatformWallet =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'setPlatformWallet',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"withdrawLendingDeskLiquidity"`
 */
export const useWriteIMagnifyCashV1WithdrawLendingDeskLiquidity =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'withdrawLendingDeskLiquidity',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__
 */
export const useSimulateIMagnifyCashV1 =
  /*#__PURE__*/ createUseSimulateContract({ abi: iMagnifyCashV1Abi })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"depositLendingDeskLiquidity"`
 */
export const useSimulateIMagnifyCashV1DepositLendingDeskLiquidity =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'depositLendingDeskLiquidity',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"initializeNewLendingDesk"`
 */
export const useSimulateIMagnifyCashV1InitializeNewLendingDesk =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'initializeNewLendingDesk',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"initializeNewLoan"`
 */
export const useSimulateIMagnifyCashV1InitializeNewLoan =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'initializeNewLoan',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"liquidateDefaultedLoan"`
 */
export const useSimulateIMagnifyCashV1LiquidateDefaultedLoan =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'liquidateDefaultedLoan',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"makeLoanPayment"`
 */
export const useSimulateIMagnifyCashV1MakeLoanPayment =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'makeLoanPayment',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"removeLendingDeskLoanConfig"`
 */
export const useSimulateIMagnifyCashV1RemoveLendingDeskLoanConfig =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'removeLendingDeskLoanConfig',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"setLendingDeskLoanConfigs"`
 */
export const useSimulateIMagnifyCashV1SetLendingDeskLoanConfigs =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'setLendingDeskLoanConfigs',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"setLendingDeskState"`
 */
export const useSimulateIMagnifyCashV1SetLendingDeskState =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'setLendingDeskState',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"setLoanOriginationFee"`
 */
export const useSimulateIMagnifyCashV1SetLoanOriginationFee =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'setLoanOriginationFee',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"setPaused"`
 */
export const useSimulateIMagnifyCashV1SetPaused =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'setPaused',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"setPlatformWallet"`
 */
export const useSimulateIMagnifyCashV1SetPlatformWallet =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'setPlatformWallet',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyCashV1Abi}__ and `functionName` set to `"withdrawLendingDeskLiquidity"`
 */
export const useSimulateIMagnifyCashV1WithdrawLendingDeskLiquidity =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyCashV1Abi,
    functionName: 'withdrawLendingDeskLiquidity',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__
 */
export const useReadIMagnifyErc721V1 = /*#__PURE__*/ createUseReadContract({
  abi: iMagnifyErc721V1Abi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadIMagnifyErc721V1BalanceOf =
  /*#__PURE__*/ createUseReadContract({
    abi: iMagnifyErc721V1Abi,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `functionName` set to `"getApproved"`
 */
export const useReadIMagnifyErc721V1GetApproved =
  /*#__PURE__*/ createUseReadContract({
    abi: iMagnifyErc721V1Abi,
    functionName: 'getApproved',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `functionName` set to `"isApprovedForAll"`
 */
export const useReadIMagnifyErc721V1IsApprovedForAll =
  /*#__PURE__*/ createUseReadContract({
    abi: iMagnifyErc721V1Abi,
    functionName: 'isApprovedForAll',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `functionName` set to `"ownerOf"`
 */
export const useReadIMagnifyErc721V1OwnerOf =
  /*#__PURE__*/ createUseReadContract({
    abi: iMagnifyErc721V1Abi,
    functionName: 'ownerOf',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadIMagnifyErc721V1SupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: iMagnifyErc721V1Abi,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__
 */
export const useWriteIMagnifyErc721V1 = /*#__PURE__*/ createUseWriteContract({
  abi: iMagnifyErc721V1Abi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `functionName` set to `"approve"`
 */
export const useWriteIMagnifyErc721V1Approve =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyErc721V1Abi,
    functionName: 'approve',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `functionName` set to `"burn"`
 */
export const useWriteIMagnifyErc721V1Burn =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyErc721V1Abi,
    functionName: 'burn',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `functionName` set to `"mint"`
 */
export const useWriteIMagnifyErc721V1Mint =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyErc721V1Abi,
    functionName: 'mint',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useWriteIMagnifyErc721V1SafeTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyErc721V1Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useWriteIMagnifyErc721V1SetApprovalForAll =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyErc721V1Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteIMagnifyErc721V1TransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: iMagnifyErc721V1Abi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__
 */
export const useSimulateIMagnifyErc721V1 =
  /*#__PURE__*/ createUseSimulateContract({ abi: iMagnifyErc721V1Abi })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `functionName` set to `"approve"`
 */
export const useSimulateIMagnifyErc721V1Approve =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyErc721V1Abi,
    functionName: 'approve',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `functionName` set to `"burn"`
 */
export const useSimulateIMagnifyErc721V1Burn =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyErc721V1Abi,
    functionName: 'burn',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `functionName` set to `"mint"`
 */
export const useSimulateIMagnifyErc721V1Mint =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyErc721V1Abi,
    functionName: 'mint',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useSimulateIMagnifyErc721V1SafeTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyErc721V1Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useSimulateIMagnifyErc721V1SetApprovalForAll =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyErc721V1Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateIMagnifyErc721V1TransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: iMagnifyErc721V1Abi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__
 */
export const useWatchIMagnifyErc721V1Event =
  /*#__PURE__*/ createUseWatchContractEvent({ abi: iMagnifyErc721V1Abi })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `eventName` set to `"Approval"`
 */
export const useWatchIMagnifyErc721V1ApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: iMagnifyErc721V1Abi,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `eventName` set to `"ApprovalForAll"`
 */
export const useWatchIMagnifyErc721V1ApprovalForAllEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: iMagnifyErc721V1Abi,
    eventName: 'ApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link iMagnifyErc721V1Abi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchIMagnifyErc721V1TransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: iMagnifyErc721V1Abi,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyCashV1Abi}__
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useReadMagnifyCashV1 = /*#__PURE__*/ createUseReadContract({
  abi: magnifyCashV1Abi,
  address: magnifyCashV1Address,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"getLoanAmountDue"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useReadMagnifyCashV1GetLoanAmountDue =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'getLoanAmountDue',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"lendingDeskIdCounter"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useReadMagnifyCashV1LendingDeskIdCounter =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'lendingDeskIdCounter',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"lendingDeskLoanConfigs"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useReadMagnifyCashV1LendingDeskLoanConfigs =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'lendingDeskLoanConfigs',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"lendingDesks"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useReadMagnifyCashV1LendingDesks =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'lendingDesks',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"lendingKeys"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useReadMagnifyCashV1LendingKeys =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'lendingKeys',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"loanIdCounter"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useReadMagnifyCashV1LoanIdCounter =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'loanIdCounter',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"loanOriginationFee"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useReadMagnifyCashV1LoanOriginationFee =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'loanOriginationFee',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"loans"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useReadMagnifyCashV1Loans = /*#__PURE__*/ createUseReadContract({
  abi: magnifyCashV1Abi,
  address: magnifyCashV1Address,
  functionName: 'loans',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"obligationNotes"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useReadMagnifyCashV1ObligationNotes =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'obligationNotes',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"owner"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useReadMagnifyCashV1Owner = /*#__PURE__*/ createUseReadContract({
  abi: magnifyCashV1Abi,
  address: magnifyCashV1Address,
  functionName: 'owner',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"ownershipHandoverExpiresAt"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useReadMagnifyCashV1OwnershipHandoverExpiresAt =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'ownershipHandoverExpiresAt',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"paused"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useReadMagnifyCashV1Paused = /*#__PURE__*/ createUseReadContract({
  abi: magnifyCashV1Abi,
  address: magnifyCashV1Address,
  functionName: 'paused',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"platformWallet"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useReadMagnifyCashV1PlatformWallet =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'platformWallet',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"supportsInterface"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useReadMagnifyCashV1SupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1 = /*#__PURE__*/ createUseWriteContract({
  abi: magnifyCashV1Abi,
  address: magnifyCashV1Address,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"cancelOwnershipHandover"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1CancelOwnershipHandover =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'cancelOwnershipHandover',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"completeOwnershipHandover"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1CompleteOwnershipHandover =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'completeOwnershipHandover',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"depositLendingDeskLiquidity"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1DepositLendingDeskLiquidity =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'depositLendingDeskLiquidity',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"initializeNewLendingDesk"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1InitializeNewLendingDesk =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'initializeNewLendingDesk',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"initializeNewLoan"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1InitializeNewLoan =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'initializeNewLoan',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"liquidateDefaultedLoan"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1LiquidateDefaultedLoan =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'liquidateDefaultedLoan',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"makeLoanPayment"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1MakeLoanPayment =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'makeLoanPayment',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"onERC1155BatchReceived"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1OnErc1155BatchReceived =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'onERC1155BatchReceived',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"onERC1155Received"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1OnErc1155Received =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'onERC1155Received',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"onERC721Received"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1OnErc721Received =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'onERC721Received',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"removeLendingDeskLoanConfig"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1RemoveLendingDeskLoanConfig =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'removeLendingDeskLoanConfig',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1RenounceOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"requestOwnershipHandover"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1RequestOwnershipHandover =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'requestOwnershipHandover',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"setLendingDeskLoanConfigs"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1SetLendingDeskLoanConfigs =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'setLendingDeskLoanConfigs',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"setLendingDeskState"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1SetLendingDeskState =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'setLendingDeskState',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"setLoanOriginationFee"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1SetLoanOriginationFee =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'setLoanOriginationFee',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"setPaused"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1SetPaused =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'setPaused',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"setPlatformWallet"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1SetPlatformWallet =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'setPlatformWallet',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1TransferOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"withdrawLendingDeskLiquidity"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWriteMagnifyCashV1WithdrawLendingDeskLiquidity =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'withdrawLendingDeskLiquidity',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1 = /*#__PURE__*/ createUseSimulateContract(
  { abi: magnifyCashV1Abi, address: magnifyCashV1Address },
)

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"cancelOwnershipHandover"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1CancelOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'cancelOwnershipHandover',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"completeOwnershipHandover"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1CompleteOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'completeOwnershipHandover',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"depositLendingDeskLiquidity"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1DepositLendingDeskLiquidity =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'depositLendingDeskLiquidity',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"initializeNewLendingDesk"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1InitializeNewLendingDesk =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'initializeNewLendingDesk',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"initializeNewLoan"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1InitializeNewLoan =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'initializeNewLoan',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"liquidateDefaultedLoan"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1LiquidateDefaultedLoan =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'liquidateDefaultedLoan',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"makeLoanPayment"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1MakeLoanPayment =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'makeLoanPayment',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"onERC1155BatchReceived"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1OnErc1155BatchReceived =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'onERC1155BatchReceived',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"onERC1155Received"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1OnErc1155Received =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'onERC1155Received',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"onERC721Received"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1OnErc721Received =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'onERC721Received',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"removeLendingDeskLoanConfig"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1RemoveLendingDeskLoanConfig =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'removeLendingDeskLoanConfig',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1RenounceOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"requestOwnershipHandover"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1RequestOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'requestOwnershipHandover',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"setLendingDeskLoanConfigs"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1SetLendingDeskLoanConfigs =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'setLendingDeskLoanConfigs',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"setLendingDeskState"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1SetLendingDeskState =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'setLendingDeskState',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"setLoanOriginationFee"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1SetLoanOriginationFee =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'setLoanOriginationFee',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"setPaused"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1SetPaused =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'setPaused',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"setPlatformWallet"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1SetPlatformWallet =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'setPlatformWallet',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1TransferOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `functionName` set to `"withdrawLendingDeskLiquidity"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useSimulateMagnifyCashV1WithdrawLendingDeskLiquidity =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    functionName: 'withdrawLendingDeskLiquidity',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1Event =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `eventName` set to `"DefaultedLoanLiquidated"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1DefaultedLoanLiquidatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    eventName: 'DefaultedLoanLiquidated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `eventName` set to `"LendingDeskLiquidityDeposited"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1LendingDeskLiquidityDepositedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    eventName: 'LendingDeskLiquidityDeposited',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `eventName` set to `"LendingDeskLiquidityWithdrawn"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1LendingDeskLiquidityWithdrawnEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    eventName: 'LendingDeskLiquidityWithdrawn',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `eventName` set to `"LendingDeskLoanConfigRemoved"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1LendingDeskLoanConfigRemovedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    eventName: 'LendingDeskLoanConfigRemoved',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `eventName` set to `"LendingDeskLoanConfigsSet"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1LendingDeskLoanConfigsSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    eventName: 'LendingDeskLoanConfigsSet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `eventName` set to `"LendingDeskStateSet"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1LendingDeskStateSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    eventName: 'LendingDeskStateSet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `eventName` set to `"LoanOriginationFeeSet"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1LoanOriginationFeeSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    eventName: 'LoanOriginationFeeSet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `eventName` set to `"LoanPaymentMade"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1LoanPaymentMadeEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    eventName: 'LoanPaymentMade',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `eventName` set to `"NewLendingDeskInitialized"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1NewLendingDeskInitializedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    eventName: 'NewLendingDeskInitialized',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `eventName` set to `"NewLoanInitialized"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1NewLoanInitializedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    eventName: 'NewLoanInitialized',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `eventName` set to `"OwnershipHandoverCanceled"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1OwnershipHandoverCanceledEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    eventName: 'OwnershipHandoverCanceled',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `eventName` set to `"OwnershipHandoverRequested"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1OwnershipHandoverRequestedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    eventName: 'OwnershipHandoverRequested',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `eventName` set to `"OwnershipTransferred"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1OwnershipTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    eventName: 'OwnershipTransferred',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `eventName` set to `"Paused"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1PausedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    eventName: 'Paused',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `eventName` set to `"PlatformWalletSet"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1PlatformWalletSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    eventName: 'PlatformWalletSet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `eventName` set to `"ProtocolInitialized"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1ProtocolInitializedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    eventName: 'ProtocolInitialized',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyCashV1Abi}__ and `eventName` set to `"Unpaused"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xA5FE620E35A2f7459e8cb72bd567aBA8f294867a)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0x9C8D226016492a8fE6531Fe1409aD79099Dd0729)
 * -
 * - [__View Contract on Base Sepolia Basescan__](https://sepolia.basescan.org/address/0x781EBE3865b0911D6989854dCD29DF3cd81168eB)
 * - [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x58b9F441b5c4681e1Ab74ecdE2A01698831BF2c4)
 */
export const useWatchMagnifyCashV1UnpausedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyCashV1Abi,
    address: magnifyCashV1Address,
    eventName: 'Unpaused',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__
 */
export const useReadMagnifyErc721V1 = /*#__PURE__*/ createUseReadContract({
  abi: magnifyErc721V1Abi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadMagnifyErc721V1BalanceOf =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyErc721V1Abi,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"baseURI"`
 */
export const useReadMagnifyErc721V1BaseUri =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyErc721V1Abi,
    functionName: 'baseURI',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"getApproved"`
 */
export const useReadMagnifyErc721V1GetApproved =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyErc721V1Abi,
    functionName: 'getApproved',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"isApprovedForAll"`
 */
export const useReadMagnifyErc721V1IsApprovedForAll =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyErc721V1Abi,
    functionName: 'isApprovedForAll',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"magnifyCash"`
 */
export const useReadMagnifyErc721V1MagnifyCash =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyErc721V1Abi,
    functionName: 'magnifyCash',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"name"`
 */
export const useReadMagnifyErc721V1Name = /*#__PURE__*/ createUseReadContract({
  abi: magnifyErc721V1Abi,
  functionName: 'name',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"owner"`
 */
export const useReadMagnifyErc721V1Owner = /*#__PURE__*/ createUseReadContract({
  abi: magnifyErc721V1Abi,
  functionName: 'owner',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"ownerOf"`
 */
export const useReadMagnifyErc721V1OwnerOf =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyErc721V1Abi,
    functionName: 'ownerOf',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"ownershipHandoverExpiresAt"`
 */
export const useReadMagnifyErc721V1OwnershipHandoverExpiresAt =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyErc721V1Abi,
    functionName: 'ownershipHandoverExpiresAt',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadMagnifyErc721V1SupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyErc721V1Abi,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"symbol"`
 */
export const useReadMagnifyErc721V1Symbol = /*#__PURE__*/ createUseReadContract(
  { abi: magnifyErc721V1Abi, functionName: 'symbol' },
)

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"tokenURI"`
 */
export const useReadMagnifyErc721V1TokenUri =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyErc721V1Abi,
    functionName: 'tokenURI',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__
 */
export const useWriteMagnifyErc721V1 = /*#__PURE__*/ createUseWriteContract({
  abi: magnifyErc721V1Abi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"approve"`
 */
export const useWriteMagnifyErc721V1Approve =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyErc721V1Abi,
    functionName: 'approve',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"burn"`
 */
export const useWriteMagnifyErc721V1Burn = /*#__PURE__*/ createUseWriteContract(
  { abi: magnifyErc721V1Abi, functionName: 'burn' },
)

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"cancelOwnershipHandover"`
 */
export const useWriteMagnifyErc721V1CancelOwnershipHandover =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyErc721V1Abi,
    functionName: 'cancelOwnershipHandover',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"completeOwnershipHandover"`
 */
export const useWriteMagnifyErc721V1CompleteOwnershipHandover =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyErc721V1Abi,
    functionName: 'completeOwnershipHandover',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"mint"`
 */
export const useWriteMagnifyErc721V1Mint = /*#__PURE__*/ createUseWriteContract(
  { abi: magnifyErc721V1Abi, functionName: 'mint' },
)

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useWriteMagnifyErc721V1RenounceOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyErc721V1Abi,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"requestOwnershipHandover"`
 */
export const useWriteMagnifyErc721V1RequestOwnershipHandover =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyErc721V1Abi,
    functionName: 'requestOwnershipHandover',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useWriteMagnifyErc721V1SafeTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyErc721V1Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useWriteMagnifyErc721V1SetApprovalForAll =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyErc721V1Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"setBaseURI"`
 */
export const useWriteMagnifyErc721V1SetBaseUri =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyErc721V1Abi,
    functionName: 'setBaseURI',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"setMagnifyCash"`
 */
export const useWriteMagnifyErc721V1SetMagnifyCash =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyErc721V1Abi,
    functionName: 'setMagnifyCash',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteMagnifyErc721V1TransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyErc721V1Abi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"transferOwnership"`
 */
export const useWriteMagnifyErc721V1TransferOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyErc721V1Abi,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__
 */
export const useSimulateMagnifyErc721V1 =
  /*#__PURE__*/ createUseSimulateContract({ abi: magnifyErc721V1Abi })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"approve"`
 */
export const useSimulateMagnifyErc721V1Approve =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyErc721V1Abi,
    functionName: 'approve',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"burn"`
 */
export const useSimulateMagnifyErc721V1Burn =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyErc721V1Abi,
    functionName: 'burn',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"cancelOwnershipHandover"`
 */
export const useSimulateMagnifyErc721V1CancelOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyErc721V1Abi,
    functionName: 'cancelOwnershipHandover',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"completeOwnershipHandover"`
 */
export const useSimulateMagnifyErc721V1CompleteOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyErc721V1Abi,
    functionName: 'completeOwnershipHandover',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"mint"`
 */
export const useSimulateMagnifyErc721V1Mint =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyErc721V1Abi,
    functionName: 'mint',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useSimulateMagnifyErc721V1RenounceOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyErc721V1Abi,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"requestOwnershipHandover"`
 */
export const useSimulateMagnifyErc721V1RequestOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyErc721V1Abi,
    functionName: 'requestOwnershipHandover',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useSimulateMagnifyErc721V1SafeTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyErc721V1Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useSimulateMagnifyErc721V1SetApprovalForAll =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyErc721V1Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"setBaseURI"`
 */
export const useSimulateMagnifyErc721V1SetBaseUri =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyErc721V1Abi,
    functionName: 'setBaseURI',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"setMagnifyCash"`
 */
export const useSimulateMagnifyErc721V1SetMagnifyCash =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyErc721V1Abi,
    functionName: 'setMagnifyCash',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateMagnifyErc721V1TransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyErc721V1Abi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `functionName` set to `"transferOwnership"`
 */
export const useSimulateMagnifyErc721V1TransferOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyErc721V1Abi,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyErc721V1Abi}__
 */
export const useWatchMagnifyErc721V1Event =
  /*#__PURE__*/ createUseWatchContractEvent({ abi: magnifyErc721V1Abi })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `eventName` set to `"Approval"`
 */
export const useWatchMagnifyErc721V1ApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyErc721V1Abi,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `eventName` set to `"ApprovalForAll"`
 */
export const useWatchMagnifyErc721V1ApprovalForAllEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyErc721V1Abi,
    eventName: 'ApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `eventName` set to `"BaseURISet"`
 */
export const useWatchMagnifyErc721V1BaseUriSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyErc721V1Abi,
    eventName: 'BaseURISet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `eventName` set to `"Initialized"`
 */
export const useWatchMagnifyErc721V1InitializedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyErc721V1Abi,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `eventName` set to `"MagnifyCashSet"`
 */
export const useWatchMagnifyErc721V1MagnifyCashSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyErc721V1Abi,
    eventName: 'MagnifyCashSet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `eventName` set to `"OwnershipHandoverCanceled"`
 */
export const useWatchMagnifyErc721V1OwnershipHandoverCanceledEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyErc721V1Abi,
    eventName: 'OwnershipHandoverCanceled',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `eventName` set to `"OwnershipHandoverRequested"`
 */
export const useWatchMagnifyErc721V1OwnershipHandoverRequestedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyErc721V1Abi,
    eventName: 'OwnershipHandoverRequested',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `eventName` set to `"OwnershipTransferred"`
 */
export const useWatchMagnifyErc721V1OwnershipTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyErc721V1Abi,
    eventName: 'OwnershipTransferred',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyErc721V1Abi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchMagnifyErc721V1TransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyErc721V1Abi,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__
 */
export const useReadMagnifyLendingKeysV1 = /*#__PURE__*/ createUseReadContract({
  abi: magnifyLendingKeysV1Abi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadMagnifyLendingKeysV1BalanceOf =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"baseURI"`
 */
export const useReadMagnifyLendingKeysV1BaseUri =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'baseURI',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"getApproved"`
 */
export const useReadMagnifyLendingKeysV1GetApproved =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'getApproved',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"isApprovedForAll"`
 */
export const useReadMagnifyLendingKeysV1IsApprovedForAll =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'isApprovedForAll',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"magnifyCash"`
 */
export const useReadMagnifyLendingKeysV1MagnifyCash =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'magnifyCash',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"name"`
 */
export const useReadMagnifyLendingKeysV1Name =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'name',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"owner"`
 */
export const useReadMagnifyLendingKeysV1Owner =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'owner',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"ownerOf"`
 */
export const useReadMagnifyLendingKeysV1OwnerOf =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'ownerOf',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"ownershipHandoverExpiresAt"`
 */
export const useReadMagnifyLendingKeysV1OwnershipHandoverExpiresAt =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'ownershipHandoverExpiresAt',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadMagnifyLendingKeysV1SupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"symbol"`
 */
export const useReadMagnifyLendingKeysV1Symbol =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"tokenURI"`
 */
export const useReadMagnifyLendingKeysV1TokenUri =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'tokenURI',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__
 */
export const useWriteMagnifyLendingKeysV1 =
  /*#__PURE__*/ createUseWriteContract({ abi: magnifyLendingKeysV1Abi })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"approve"`
 */
export const useWriteMagnifyLendingKeysV1Approve =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'approve',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"burn"`
 */
export const useWriteMagnifyLendingKeysV1Burn =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'burn',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"cancelOwnershipHandover"`
 */
export const useWriteMagnifyLendingKeysV1CancelOwnershipHandover =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'cancelOwnershipHandover',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"completeOwnershipHandover"`
 */
export const useWriteMagnifyLendingKeysV1CompleteOwnershipHandover =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'completeOwnershipHandover',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"mint"`
 */
export const useWriteMagnifyLendingKeysV1Mint =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'mint',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useWriteMagnifyLendingKeysV1RenounceOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"requestOwnershipHandover"`
 */
export const useWriteMagnifyLendingKeysV1RequestOwnershipHandover =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'requestOwnershipHandover',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useWriteMagnifyLendingKeysV1SafeTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useWriteMagnifyLendingKeysV1SetApprovalForAll =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"setBaseURI"`
 */
export const useWriteMagnifyLendingKeysV1SetBaseUri =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'setBaseURI',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"setMagnifyCash"`
 */
export const useWriteMagnifyLendingKeysV1SetMagnifyCash =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'setMagnifyCash',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteMagnifyLendingKeysV1TransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"transferOwnership"`
 */
export const useWriteMagnifyLendingKeysV1TransferOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__
 */
export const useSimulateMagnifyLendingKeysV1 =
  /*#__PURE__*/ createUseSimulateContract({ abi: magnifyLendingKeysV1Abi })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"approve"`
 */
export const useSimulateMagnifyLendingKeysV1Approve =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'approve',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"burn"`
 */
export const useSimulateMagnifyLendingKeysV1Burn =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'burn',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"cancelOwnershipHandover"`
 */
export const useSimulateMagnifyLendingKeysV1CancelOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'cancelOwnershipHandover',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"completeOwnershipHandover"`
 */
export const useSimulateMagnifyLendingKeysV1CompleteOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'completeOwnershipHandover',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"mint"`
 */
export const useSimulateMagnifyLendingKeysV1Mint =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'mint',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useSimulateMagnifyLendingKeysV1RenounceOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"requestOwnershipHandover"`
 */
export const useSimulateMagnifyLendingKeysV1RequestOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'requestOwnershipHandover',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useSimulateMagnifyLendingKeysV1SafeTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useSimulateMagnifyLendingKeysV1SetApprovalForAll =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"setBaseURI"`
 */
export const useSimulateMagnifyLendingKeysV1SetBaseUri =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'setBaseURI',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"setMagnifyCash"`
 */
export const useSimulateMagnifyLendingKeysV1SetMagnifyCash =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'setMagnifyCash',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateMagnifyLendingKeysV1TransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `functionName` set to `"transferOwnership"`
 */
export const useSimulateMagnifyLendingKeysV1TransferOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyLendingKeysV1Abi,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__
 */
export const useWatchMagnifyLendingKeysV1Event =
  /*#__PURE__*/ createUseWatchContractEvent({ abi: magnifyLendingKeysV1Abi })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `eventName` set to `"Approval"`
 */
export const useWatchMagnifyLendingKeysV1ApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyLendingKeysV1Abi,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `eventName` set to `"ApprovalForAll"`
 */
export const useWatchMagnifyLendingKeysV1ApprovalForAllEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyLendingKeysV1Abi,
    eventName: 'ApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `eventName` set to `"BaseURISet"`
 */
export const useWatchMagnifyLendingKeysV1BaseUriSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyLendingKeysV1Abi,
    eventName: 'BaseURISet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `eventName` set to `"Initialized"`
 */
export const useWatchMagnifyLendingKeysV1InitializedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyLendingKeysV1Abi,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `eventName` set to `"MagnifyCashSet"`
 */
export const useWatchMagnifyLendingKeysV1MagnifyCashSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyLendingKeysV1Abi,
    eventName: 'MagnifyCashSet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `eventName` set to `"OwnershipHandoverCanceled"`
 */
export const useWatchMagnifyLendingKeysV1OwnershipHandoverCanceledEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyLendingKeysV1Abi,
    eventName: 'OwnershipHandoverCanceled',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `eventName` set to `"OwnershipHandoverRequested"`
 */
export const useWatchMagnifyLendingKeysV1OwnershipHandoverRequestedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyLendingKeysV1Abi,
    eventName: 'OwnershipHandoverRequested',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `eventName` set to `"OwnershipTransferred"`
 */
export const useWatchMagnifyLendingKeysV1OwnershipTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyLendingKeysV1Abi,
    eventName: 'OwnershipTransferred',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyLendingKeysV1Abi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchMagnifyLendingKeysV1TransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyLendingKeysV1Abi,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__
 */
export const useReadMagnifyObligationNotesV1 =
  /*#__PURE__*/ createUseReadContract({ abi: magnifyObligationNotesV1Abi })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadMagnifyObligationNotesV1BalanceOf =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"baseURI"`
 */
export const useReadMagnifyObligationNotesV1BaseUri =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'baseURI',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"getApproved"`
 */
export const useReadMagnifyObligationNotesV1GetApproved =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'getApproved',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"isApprovedForAll"`
 */
export const useReadMagnifyObligationNotesV1IsApprovedForAll =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'isApprovedForAll',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"magnifyCash"`
 */
export const useReadMagnifyObligationNotesV1MagnifyCash =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'magnifyCash',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"name"`
 */
export const useReadMagnifyObligationNotesV1Name =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'name',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"owner"`
 */
export const useReadMagnifyObligationNotesV1Owner =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'owner',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"ownerOf"`
 */
export const useReadMagnifyObligationNotesV1OwnerOf =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'ownerOf',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"ownershipHandoverExpiresAt"`
 */
export const useReadMagnifyObligationNotesV1OwnershipHandoverExpiresAt =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'ownershipHandoverExpiresAt',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadMagnifyObligationNotesV1SupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"symbol"`
 */
export const useReadMagnifyObligationNotesV1Symbol =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"tokenURI"`
 */
export const useReadMagnifyObligationNotesV1TokenUri =
  /*#__PURE__*/ createUseReadContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'tokenURI',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__
 */
export const useWriteMagnifyObligationNotesV1 =
  /*#__PURE__*/ createUseWriteContract({ abi: magnifyObligationNotesV1Abi })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"approve"`
 */
export const useWriteMagnifyObligationNotesV1Approve =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'approve',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"burn"`
 */
export const useWriteMagnifyObligationNotesV1Burn =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'burn',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"cancelOwnershipHandover"`
 */
export const useWriteMagnifyObligationNotesV1CancelOwnershipHandover =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'cancelOwnershipHandover',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"completeOwnershipHandover"`
 */
export const useWriteMagnifyObligationNotesV1CompleteOwnershipHandover =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'completeOwnershipHandover',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"mint"`
 */
export const useWriteMagnifyObligationNotesV1Mint =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'mint',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useWriteMagnifyObligationNotesV1RenounceOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"requestOwnershipHandover"`
 */
export const useWriteMagnifyObligationNotesV1RequestOwnershipHandover =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'requestOwnershipHandover',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useWriteMagnifyObligationNotesV1SafeTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useWriteMagnifyObligationNotesV1SetApprovalForAll =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"setBaseURI"`
 */
export const useWriteMagnifyObligationNotesV1SetBaseUri =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'setBaseURI',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"setMagnifyCash"`
 */
export const useWriteMagnifyObligationNotesV1SetMagnifyCash =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'setMagnifyCash',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteMagnifyObligationNotesV1TransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"transferOwnership"`
 */
export const useWriteMagnifyObligationNotesV1TransferOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__
 */
export const useSimulateMagnifyObligationNotesV1 =
  /*#__PURE__*/ createUseSimulateContract({ abi: magnifyObligationNotesV1Abi })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"approve"`
 */
export const useSimulateMagnifyObligationNotesV1Approve =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'approve',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"burn"`
 */
export const useSimulateMagnifyObligationNotesV1Burn =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'burn',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"cancelOwnershipHandover"`
 */
export const useSimulateMagnifyObligationNotesV1CancelOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'cancelOwnershipHandover',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"completeOwnershipHandover"`
 */
export const useSimulateMagnifyObligationNotesV1CompleteOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'completeOwnershipHandover',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"mint"`
 */
export const useSimulateMagnifyObligationNotesV1Mint =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'mint',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useSimulateMagnifyObligationNotesV1RenounceOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"requestOwnershipHandover"`
 */
export const useSimulateMagnifyObligationNotesV1RequestOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'requestOwnershipHandover',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useSimulateMagnifyObligationNotesV1SafeTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useSimulateMagnifyObligationNotesV1SetApprovalForAll =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"setBaseURI"`
 */
export const useSimulateMagnifyObligationNotesV1SetBaseUri =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'setBaseURI',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"setMagnifyCash"`
 */
export const useSimulateMagnifyObligationNotesV1SetMagnifyCash =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'setMagnifyCash',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateMagnifyObligationNotesV1TransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `functionName` set to `"transferOwnership"`
 */
export const useSimulateMagnifyObligationNotesV1TransferOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: magnifyObligationNotesV1Abi,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__
 */
export const useWatchMagnifyObligationNotesV1Event =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyObligationNotesV1Abi,
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `eventName` set to `"Approval"`
 */
export const useWatchMagnifyObligationNotesV1ApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyObligationNotesV1Abi,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `eventName` set to `"ApprovalForAll"`
 */
export const useWatchMagnifyObligationNotesV1ApprovalForAllEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyObligationNotesV1Abi,
    eventName: 'ApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `eventName` set to `"BaseURISet"`
 */
export const useWatchMagnifyObligationNotesV1BaseUriSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyObligationNotesV1Abi,
    eventName: 'BaseURISet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `eventName` set to `"Initialized"`
 */
export const useWatchMagnifyObligationNotesV1InitializedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyObligationNotesV1Abi,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `eventName` set to `"MagnifyCashSet"`
 */
export const useWatchMagnifyObligationNotesV1MagnifyCashSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyObligationNotesV1Abi,
    eventName: 'MagnifyCashSet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `eventName` set to `"OwnershipHandoverCanceled"`
 */
export const useWatchMagnifyObligationNotesV1OwnershipHandoverCanceledEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyObligationNotesV1Abi,
    eventName: 'OwnershipHandoverCanceled',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `eventName` set to `"OwnershipHandoverRequested"`
 */
export const useWatchMagnifyObligationNotesV1OwnershipHandoverRequestedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyObligationNotesV1Abi,
    eventName: 'OwnershipHandoverRequested',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `eventName` set to `"OwnershipTransferred"`
 */
export const useWatchMagnifyObligationNotesV1OwnershipTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyObligationNotesV1Abi,
    eventName: 'OwnershipTransferred',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link magnifyObligationNotesV1Abi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchMagnifyObligationNotesV1TransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: magnifyObligationNotesV1Abi,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ownableAbi}__
 */
export const useReadOwnable = /*#__PURE__*/ createUseReadContract({
  abi: ownableAbi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ownableAbi}__ and `functionName` set to `"owner"`
 */
export const useReadOwnableOwner = /*#__PURE__*/ createUseReadContract({
  abi: ownableAbi,
  functionName: 'owner',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ownableAbi}__ and `functionName` set to `"ownershipHandoverExpiresAt"`
 */
export const useReadOwnableOwnershipHandoverExpiresAt =
  /*#__PURE__*/ createUseReadContract({
    abi: ownableAbi,
    functionName: 'ownershipHandoverExpiresAt',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ownableAbi}__
 */
export const useWriteOwnable = /*#__PURE__*/ createUseWriteContract({
  abi: ownableAbi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ownableAbi}__ and `functionName` set to `"cancelOwnershipHandover"`
 */
export const useWriteOwnableCancelOwnershipHandover =
  /*#__PURE__*/ createUseWriteContract({
    abi: ownableAbi,
    functionName: 'cancelOwnershipHandover',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ownableAbi}__ and `functionName` set to `"completeOwnershipHandover"`
 */
export const useWriteOwnableCompleteOwnershipHandover =
  /*#__PURE__*/ createUseWriteContract({
    abi: ownableAbi,
    functionName: 'completeOwnershipHandover',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ownableAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useWriteOwnableRenounceOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: ownableAbi,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ownableAbi}__ and `functionName` set to `"requestOwnershipHandover"`
 */
export const useWriteOwnableRequestOwnershipHandover =
  /*#__PURE__*/ createUseWriteContract({
    abi: ownableAbi,
    functionName: 'requestOwnershipHandover',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ownableAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useWriteOwnableTransferOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: ownableAbi,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ownableAbi}__
 */
export const useSimulateOwnable = /*#__PURE__*/ createUseSimulateContract({
  abi: ownableAbi,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ownableAbi}__ and `functionName` set to `"cancelOwnershipHandover"`
 */
export const useSimulateOwnableCancelOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ownableAbi,
    functionName: 'cancelOwnershipHandover',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ownableAbi}__ and `functionName` set to `"completeOwnershipHandover"`
 */
export const useSimulateOwnableCompleteOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ownableAbi,
    functionName: 'completeOwnershipHandover',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ownableAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useSimulateOwnableRenounceOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ownableAbi,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ownableAbi}__ and `functionName` set to `"requestOwnershipHandover"`
 */
export const useSimulateOwnableRequestOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ownableAbi,
    functionName: 'requestOwnershipHandover',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ownableAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useSimulateOwnableTransferOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: ownableAbi,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ownableAbi}__
 */
export const useWatchOwnableEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: ownableAbi,
})

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ownableAbi}__ and `eventName` set to `"OwnershipHandoverCanceled"`
 */
export const useWatchOwnableOwnershipHandoverCanceledEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ownableAbi,
    eventName: 'OwnershipHandoverCanceled',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ownableAbi}__ and `eventName` set to `"OwnershipHandoverRequested"`
 */
export const useWatchOwnableOwnershipHandoverRequestedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ownableAbi,
    eventName: 'OwnershipHandoverRequested',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ownableAbi}__ and `eventName` set to `"OwnershipTransferred"`
 */
export const useWatchOwnableOwnershipTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: ownableAbi,
    eventName: 'OwnershipTransferred',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link pausableAbi}__
 */
export const useReadPausable = /*#__PURE__*/ createUseReadContract({
  abi: pausableAbi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link pausableAbi}__ and `functionName` set to `"paused"`
 */
export const useReadPausablePaused = /*#__PURE__*/ createUseReadContract({
  abi: pausableAbi,
  functionName: 'paused',
})

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link pausableAbi}__
 */
export const useWatchPausableEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: pausableAbi,
})

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link pausableAbi}__ and `eventName` set to `"Paused"`
 */
export const useWatchPausablePausedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: pausableAbi,
    eventName: 'Paused',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link pausableAbi}__ and `eventName` set to `"Unpaused"`
 */
export const useWatchPausableUnpausedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: pausableAbi,
    eventName: 'Unpaused',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc1155Abi}__
 */
export const useReadTestErc1155 = /*#__PURE__*/ createUseReadContract({
  abi: testErc1155Abi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc1155Abi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadTestErc1155BalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: testErc1155Abi,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc1155Abi}__ and `functionName` set to `"balanceOfBatch"`
 */
export const useReadTestErc1155BalanceOfBatch =
  /*#__PURE__*/ createUseReadContract({
    abi: testErc1155Abi,
    functionName: 'balanceOfBatch',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc1155Abi}__ and `functionName` set to `"isApprovedForAll"`
 */
export const useReadTestErc1155IsApprovedForAll =
  /*#__PURE__*/ createUseReadContract({
    abi: testErc1155Abi,
    functionName: 'isApprovedForAll',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc1155Abi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadTestErc1155SupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: testErc1155Abi,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc1155Abi}__ and `functionName` set to `"uri"`
 */
export const useReadTestErc1155Uri = /*#__PURE__*/ createUseReadContract({
  abi: testErc1155Abi,
  functionName: 'uri',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link testErc1155Abi}__
 */
export const useWriteTestErc1155 = /*#__PURE__*/ createUseWriteContract({
  abi: testErc1155Abi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link testErc1155Abi}__ and `functionName` set to `"mint"`
 */
export const useWriteTestErc1155Mint = /*#__PURE__*/ createUseWriteContract({
  abi: testErc1155Abi,
  functionName: 'mint',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link testErc1155Abi}__ and `functionName` set to `"mintBatch"`
 */
export const useWriteTestErc1155MintBatch =
  /*#__PURE__*/ createUseWriteContract({
    abi: testErc1155Abi,
    functionName: 'mintBatch',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link testErc1155Abi}__ and `functionName` set to `"safeBatchTransferFrom"`
 */
export const useWriteTestErc1155SafeBatchTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: testErc1155Abi,
    functionName: 'safeBatchTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link testErc1155Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useWriteTestErc1155SafeTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: testErc1155Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link testErc1155Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useWriteTestErc1155SetApprovalForAll =
  /*#__PURE__*/ createUseWriteContract({
    abi: testErc1155Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link testErc1155Abi}__
 */
export const useSimulateTestErc1155 = /*#__PURE__*/ createUseSimulateContract({
  abi: testErc1155Abi,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link testErc1155Abi}__ and `functionName` set to `"mint"`
 */
export const useSimulateTestErc1155Mint =
  /*#__PURE__*/ createUseSimulateContract({
    abi: testErc1155Abi,
    functionName: 'mint',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link testErc1155Abi}__ and `functionName` set to `"mintBatch"`
 */
export const useSimulateTestErc1155MintBatch =
  /*#__PURE__*/ createUseSimulateContract({
    abi: testErc1155Abi,
    functionName: 'mintBatch',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link testErc1155Abi}__ and `functionName` set to `"safeBatchTransferFrom"`
 */
export const useSimulateTestErc1155SafeBatchTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: testErc1155Abi,
    functionName: 'safeBatchTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link testErc1155Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useSimulateTestErc1155SafeTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: testErc1155Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link testErc1155Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useSimulateTestErc1155SetApprovalForAll =
  /*#__PURE__*/ createUseSimulateContract({
    abi: testErc1155Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link testErc1155Abi}__
 */
export const useWatchTestErc1155Event =
  /*#__PURE__*/ createUseWatchContractEvent({ abi: testErc1155Abi })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link testErc1155Abi}__ and `eventName` set to `"ApprovalForAll"`
 */
export const useWatchTestErc1155ApprovalForAllEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: testErc1155Abi,
    eventName: 'ApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link testErc1155Abi}__ and `eventName` set to `"TransferBatch"`
 */
export const useWatchTestErc1155TransferBatchEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: testErc1155Abi,
    eventName: 'TransferBatch',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link testErc1155Abi}__ and `eventName` set to `"TransferSingle"`
 */
export const useWatchTestErc1155TransferSingleEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: testErc1155Abi,
    eventName: 'TransferSingle',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link testErc1155Abi}__ and `eventName` set to `"URI"`
 */
export const useWatchTestErc1155UriEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: testErc1155Abi,
    eventName: 'URI',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc20Abi}__
 */
export const useReadTestErc20 = /*#__PURE__*/ createUseReadContract({
  abi: testErc20Abi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc20Abi}__ and `functionName` set to `"allowance"`
 */
export const useReadTestErc20Allowance = /*#__PURE__*/ createUseReadContract({
  abi: testErc20Abi,
  functionName: 'allowance',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc20Abi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadTestErc20BalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: testErc20Abi,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc20Abi}__ and `functionName` set to `"decimals"`
 */
export const useReadTestErc20Decimals = /*#__PURE__*/ createUseReadContract({
  abi: testErc20Abi,
  functionName: 'decimals',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc20Abi}__ and `functionName` set to `"name"`
 */
export const useReadTestErc20Name = /*#__PURE__*/ createUseReadContract({
  abi: testErc20Abi,
  functionName: 'name',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc20Abi}__ and `functionName` set to `"symbol"`
 */
export const useReadTestErc20Symbol = /*#__PURE__*/ createUseReadContract({
  abi: testErc20Abi,
  functionName: 'symbol',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc20Abi}__ and `functionName` set to `"totalSupply"`
 */
export const useReadTestErc20TotalSupply = /*#__PURE__*/ createUseReadContract({
  abi: testErc20Abi,
  functionName: 'totalSupply',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link testErc20Abi}__
 */
export const useWriteTestErc20 = /*#__PURE__*/ createUseWriteContract({
  abi: testErc20Abi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link testErc20Abi}__ and `functionName` set to `"approve"`
 */
export const useWriteTestErc20Approve = /*#__PURE__*/ createUseWriteContract({
  abi: testErc20Abi,
  functionName: 'approve',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link testErc20Abi}__ and `functionName` set to `"mint"`
 */
export const useWriteTestErc20Mint = /*#__PURE__*/ createUseWriteContract({
  abi: testErc20Abi,
  functionName: 'mint',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link testErc20Abi}__ and `functionName` set to `"transfer"`
 */
export const useWriteTestErc20Transfer = /*#__PURE__*/ createUseWriteContract({
  abi: testErc20Abi,
  functionName: 'transfer',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link testErc20Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteTestErc20TransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: testErc20Abi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link testErc20Abi}__
 */
export const useSimulateTestErc20 = /*#__PURE__*/ createUseSimulateContract({
  abi: testErc20Abi,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link testErc20Abi}__ and `functionName` set to `"approve"`
 */
export const useSimulateTestErc20Approve =
  /*#__PURE__*/ createUseSimulateContract({
    abi: testErc20Abi,
    functionName: 'approve',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link testErc20Abi}__ and `functionName` set to `"mint"`
 */
export const useSimulateTestErc20Mint = /*#__PURE__*/ createUseSimulateContract(
  { abi: testErc20Abi, functionName: 'mint' },
)

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link testErc20Abi}__ and `functionName` set to `"transfer"`
 */
export const useSimulateTestErc20Transfer =
  /*#__PURE__*/ createUseSimulateContract({
    abi: testErc20Abi,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link testErc20Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateTestErc20TransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: testErc20Abi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link testErc20Abi}__
 */
export const useWatchTestErc20Event = /*#__PURE__*/ createUseWatchContractEvent(
  { abi: testErc20Abi },
)

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link testErc20Abi}__ and `eventName` set to `"Approval"`
 */
export const useWatchTestErc20ApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: testErc20Abi,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link testErc20Abi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchTestErc20TransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: testErc20Abi,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc721Abi}__
 */
export const useReadTestErc721 = /*#__PURE__*/ createUseReadContract({
  abi: testErc721Abi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadTestErc721BalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: testErc721Abi,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"baseURI"`
 */
export const useReadTestErc721BaseUri = /*#__PURE__*/ createUseReadContract({
  abi: testErc721Abi,
  functionName: 'baseURI',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"getApproved"`
 */
export const useReadTestErc721GetApproved = /*#__PURE__*/ createUseReadContract(
  { abi: testErc721Abi, functionName: 'getApproved' },
)

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"isApprovedForAll"`
 */
export const useReadTestErc721IsApprovedForAll =
  /*#__PURE__*/ createUseReadContract({
    abi: testErc721Abi,
    functionName: 'isApprovedForAll',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"name"`
 */
export const useReadTestErc721Name = /*#__PURE__*/ createUseReadContract({
  abi: testErc721Abi,
  functionName: 'name',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"ownerOf"`
 */
export const useReadTestErc721OwnerOf = /*#__PURE__*/ createUseReadContract({
  abi: testErc721Abi,
  functionName: 'ownerOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadTestErc721SupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: testErc721Abi,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"symbol"`
 */
export const useReadTestErc721Symbol = /*#__PURE__*/ createUseReadContract({
  abi: testErc721Abi,
  functionName: 'symbol',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"tokenURI"`
 */
export const useReadTestErc721TokenUri = /*#__PURE__*/ createUseReadContract({
  abi: testErc721Abi,
  functionName: 'tokenURI',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"totalSupply"`
 */
export const useReadTestErc721TotalSupply = /*#__PURE__*/ createUseReadContract(
  { abi: testErc721Abi, functionName: 'totalSupply' },
)

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link testErc721Abi}__
 */
export const useWriteTestErc721 = /*#__PURE__*/ createUseWriteContract({
  abi: testErc721Abi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"approve"`
 */
export const useWriteTestErc721Approve = /*#__PURE__*/ createUseWriteContract({
  abi: testErc721Abi,
  functionName: 'approve',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"mint"`
 */
export const useWriteTestErc721Mint = /*#__PURE__*/ createUseWriteContract({
  abi: testErc721Abi,
  functionName: 'mint',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useWriteTestErc721SafeTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: testErc721Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useWriteTestErc721SetApprovalForAll =
  /*#__PURE__*/ createUseWriteContract({
    abi: testErc721Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteTestErc721TransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: testErc721Abi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link testErc721Abi}__
 */
export const useSimulateTestErc721 = /*#__PURE__*/ createUseSimulateContract({
  abi: testErc721Abi,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"approve"`
 */
export const useSimulateTestErc721Approve =
  /*#__PURE__*/ createUseSimulateContract({
    abi: testErc721Abi,
    functionName: 'approve',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"mint"`
 */
export const useSimulateTestErc721Mint =
  /*#__PURE__*/ createUseSimulateContract({
    abi: testErc721Abi,
    functionName: 'mint',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useSimulateTestErc721SafeTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: testErc721Abi,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useSimulateTestErc721SetApprovalForAll =
  /*#__PURE__*/ createUseSimulateContract({
    abi: testErc721Abi,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link testErc721Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateTestErc721TransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: testErc721Abi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link testErc721Abi}__
 */
export const useWatchTestErc721Event =
  /*#__PURE__*/ createUseWatchContractEvent({ abi: testErc721Abi })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link testErc721Abi}__ and `eventName` set to `"Approval"`
 */
export const useWatchTestErc721ApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: testErc721Abi,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link testErc721Abi}__ and `eventName` set to `"ApprovalForAll"`
 */
export const useWatchTestErc721ApprovalForAllEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: testErc721Abi,
    eventName: 'ApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link testErc721Abi}__ and `eventName` set to `"ConsecutiveTransfer"`
 */
export const useWatchTestErc721ConsecutiveTransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: testErc721Abi,
    eventName: 'ConsecutiveTransfer',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link testErc721Abi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchTestErc721TransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: testErc721Abi,
    eventName: 'Transfer',
  })
